{
  "A1": "A1",
  "A2": "A2",
  "accents_and_special_characters": "Akzente und Sonderzeichen",
  "account": "Account",
  "activity": "Aktivität",
  "actor": "Schauspieler {{number}}",
  "actor_2": "Darsteller 2",
  "actor_name": "Name des Schauspielers",
  "actor_voice": "Schauspieler Stimme",
  "add_alternatives": "Alternativen hinzufügen",
  "add_another_reply": "Weitere Antwort hinzufügen",
  "add_courses": "Kurse hinzufügen",
  "add_answer": "Antwort hinzufügen",
  "add_image": "Bild hinzufügen",
  "add_image_desc": "Fügen Sie Ihrer Übung ein Bild hinzu!",
  "add_link": "Link hinzufügen",
  "add_link_desc": "Fügen Sie Ihrer Übung einen Link hinzu!",
  "all_steps_complete": "Alle Schritte abgeschlossen",
  "alternative_versions": "Alternative Versionen",
  "archive_recording_error": "Beim Archivieren der Aufnahme ist ein Problem aufgetreten",
  "assign": "Zuweisen",
  "attach_file": "Datei anhängen",
  "bot_not_found": "Chatbot nicht gefunden",
  "bot_not_found_desc": "Wir konnten diesen Chatbot nicht finden. Möglicherweise wurde er gelöscht oder auf privat gesetzt.",
  "categories": "Kategorien",
  "chart": "Diagramm",
  "choose_length_of_roleplay": "Wähle die Länge des Szenarios",
  "clear": "Löschen",
  "close_pdf": "PDF schließen",
  "comma_seperated_domains": "Durch Kommas getrennte Domains",
  "community": "Community",
  "datetime": "Datum und Uhrzeit",
  "days": "Tage",
  "days_late": "{{count}} Tage zu spät",
  "discussion": "Diskussion",
  "download_error": "Beim Herunterladen der Datei ist ein Problem aufgetreten",
  "editor_mode": "Editor-Modus",
  "email_notifications": "E-Mail-Benachrichtigungen",
  "enter_linguistic_goal": "Geben Sie Ihr linguistisches Ziel ein",
  "add_new": "Neue hinzufügen",
  "add_phrase": "Phrase hinzufügen",
  "add_phrase_desc": "Fügen Sie eine neue {{language}} Phrase hinzu, damit die Leute lernen können",
  "add_phrases": "Sätze hinzufügen",
  "add_phrases_to_enable_exercise": "Fügen Sie Sätze hinzu, um die Übung zu ermöglichen",
  "add_question": "Frage hinzufügen",
  "add_question_desc": "Stellen Sie eine Verständnisfrage. Die Frage kann mehrere richtige Antworten haben.",
  "add_review": "Bewertung hinzufügen",
  "add_review_desc": "Teilen Sie Ihre Gedanken unten",
  "add_script": "Skript Hinzufügen",
  "add_section": "Abschnitt hinzufügen",
  "add_substitution": "Substitution hinzufügen",
  "add_substitution_desc": "Mit Ersetzungen können Sie dafür sorgen, dass 'Was ist' stattdessen zu 'Was ist' erweitert wird - so können Sie besser steuern, wie Sie auf die Nachricht des Benutzers antworten!",
  "add_topic": "Thema hinzufügen",
  "add_topic_desc": "Themen sind logische Gruppierungen von Triggern. Wenn sich ein Benutzer in einem Thema befindet, kann er nur Trigger abgleichen, die zu diesem Thema gehören.",
  "add_topic_to_section": "Fügen Sie dem Abschnitt {{sectionId}} ein Thema hinzu",
  "add_trigger": "Trigger hinzufügen",
  "add_trigger_desc": "Ein Trigger ist eine Textzeile, die verwendet wird, um mit der Nachricht des Benutzers übereinzustimmen.",
  "add_variable": "Variable hinzufügen",
  "add_variable_desc": "Chatbot-Variablen sind Informationen, die Ihren Chatbot beschreiben. Mit Chatbot-Variablen können wir Antworten schreiben, in denen der Chatbot dem Benutzer etwas über sich selbst erzählen kann.",
  "add_voice": "Stimme hinzufügen",
  "all": "Alles",
  "all_topics_completed": "Alle Themen abgeschlossen",
  "alternatives": "Alternativen",
  "alternatives_desc": "Eine Liste von Wörtern oder Phrasen, die in Ihrem Chatbot wiederverwendet werden können.",
  "alternatives_name": "Name",
  "alternatives_value": "Liste der Wörter (durch Kommas getrennt)",
  "answer": "Antworten",
  "new_answer_placeholder": "Geben Sie hier Ihre Antwort ein",
  "answer_message_100": "Perfekt, tolle Arbeit",
  "answer_message_90": "Versuch es nochmal!",
  "answer_message_95": "Das war fast perfekt.",
  "answer_message_wrong": "Das war nicht ganz richtig",
  "attempt": "Versuch",
  "attempt_messages": "Übungsversuch",
  "attempt_table": "Versuche",
  "auto_translate": "Automatische Übersetzung",
  "auto_translate_phrase": "Auto-Übersetzungsphrase",
  "avg_pronunciation_score": "Avg Pronunciation Score",
  "average_pronunciation_score_tooltip": "Average pronunciation score is",
  "B1": "B1",
  "B2": "B2",
  "back": "Zurück",
  "back_to_course": "zurück zum Kurs",
  "blog": "Blog",
  "bot": "Chatbot",
  "bot-listen-and-speak": "Chatbot - Hören & Sprechen",
  "all_modes": "Alle Modi",
  "bot_information": "Chatbot-Informationen",
  "bot_intro_message": "Chatbot Einführungsnachricht",
  "bot_intro_message_helper_text": "Lassen Sie das Feld leer, wenn der Schüler das Gespräch beginnen soll.",
  "bot_name": "Chatbot Name",
  "bot_reply": "Chatbot Antwort",
  "bot_settings": "Chatbot-Einstellungen",
  "bot_title": "Chatbot-Titel",
  "bot_voice": "Chatbot Stimme",
  "bots": "Chatbots",
  "bots_not_found_desc": "Crie o primeiro Chatbot hoje",
  "bots_not_found_title": "Nenhum Chatbot encontrado",
  "C1": "C1",
  "C2": "C2",
  "cancel": "Stornieren",
  "card_A1": "A1",
  "card_A2": "A2",
  "card_B1": "B1",
  "card_B2": "B2",
  "card_C1": "C1",
  "card_C2": "C2",
  "change_app_colors": "App-Farben ändern",
  "change_language": "Sprache ändern",
  "chatbot_exercise_desc": "Chatten Sie mit einem Chatbot, um eine Konversation über ein Thema zu simulieren",
  "chatbots": "Chat-Roboter",
  "choose_avatar": "Wähle einen Nuala",
  "choose_from_file": "Wählen Sie aus der Datei",
  "classroom_code": "Klassenzimmercode",
  "classroom_code_label": "Geben Sie den Klassencode ein",
  "classroom_code_not_valid": "Klassencode ungültig",
  "classroom_created": "Klassenzimmer erstellt",
  "classroom_deleted": "Klassenzimmer gelöscht",
  "classroom_information": "Informationen zum Klassenzimmer",
  "classroom_name": "Name des Klassenzimmers",
  "classroom_not_found": "Klassenzimmer nicht gefunden",
  "classroom_not_found_desc": "Dieses Klassenzimmer wurde möglicherweise gelöscht",
  "classroom_load_error": "Klassenzimmer konnte nicht geladen werden",
  "classroom_load_error_desc": "Beim Laden dieses Klassenzimmers ist ein Fehler aufgetreten. Bitte versuche es erneut.",
  "classroom_settings": "Klassenzimmereinstellungen",
  "classrooms": "Klassenzimmer",
  "classrooms_not_found_desc": "Erstellen Sie noch heute das erste Klassenzimmer",
  "classrooms_not_found_title": "Keine Klassenzimmer gefunden",
  "collaborators": "Mitarbeiter",
  "color": "Farbe",
  "community_templates": "Community-Vorlagen",
  "completed": "Vollendet",
  "completed_icon": "Abgeschlossenes Symbol",
  "completion": "Fertigstellung",
  "completions": "Abschlüsse",
  "confirmation": "Bestätigung",
  "contact_form": "Kontakt Formular",
  "continue": "Fortsetzen",
  "continue_exercise": "Continue Exercise",
  "continue_learning": "Weiter lernen",
  "continue_teaching": "Unterrichten Sie weiter",
  "copied": "Kopiert",
  "copy_to_clipboard": "In die Zwischenablage kopieren",
  "correct": "Richtig",
  "correct_answer": "Korrekte Antwort",
  "correct_answer_percentage": "Correct Answer Percentage",
  "course": "Curso",
  "course_code": "Kurscode",
  "course_code_label": "Kurscode eingeben",
  "course_code_not_valid": "Kurscode ungültig",
  "course_created": "Kurs erstellt",
  "course_deleted": "Kurs gelöscht",
  "course_information": "Kurs Information",
  "course_name": "Kursname",
  "course_not_found": "Kurs nicht gefunden",
  "course_not_found_desc": "Dieser Kurs wurde möglicherweise gelöscht",
  "course_outline": "Kursbeschreibung",
  "course_progress": "Kursfortschritt",
  "course_settings": "Kurseinstellungen",
  "courses": "Kurse",
  "courses_not_found_desc": "Erstellen Sie noch heute den ersten Kurs",
  "courses_not_found_title": "Keine Kurse gefunden",
  "create": "Erstellen",
  "create_bot": "Criar Chatbot",
  "create_classroom": "Klassenzimmer erstellen",
  "create_course": "Kurs erstellen",
  "create_course_section": "Kursabschnitt erstellen",
  "create_course_section_desc": "Es liegt an Ihnen, wie Sie den Kurs strukturieren. Beispielstrukturen sind 'Anfänger, Mittelstufe, Fortgeschrittene' oder 'Woche 1, Woche 2, Woche 3'.",
  "create_topic": "Thema erstellen",
  "created_courses": "Kurse erstellt",
  "creation_visibility": "Öffentliche Inhalte können als Ausgangspunkt für Kreationen anderer Pädagogen verwendet werden.",
  "creator": "Schöpfer",
  "customization": "Anpassung",
  "dark_theme": "Dunkles Thema",
  "dark_theme_desc": "Verdunkelt die hellen Oberflächen der Seite und schafft ein Erlebnis, das ideal für die Nacht ist.",
  "delete_bot": "Chatbot löschen",
  "delete_bot_confirmation": "Möchten Sie diesen Chatbot wirklich löschen?",
  "delete_classroom": "Klassenzimmer löschen",
  "delete_classroom_confirmation": "Möchten Sie dieses Klassenzimmer wirklich löschen?",
  "delete_course": "Kurs löschen",
  "delete_course_confirmation": "Möchten Sie diesen Kurs wirklich löschen?",
  "delete_phrase": "Phrase löschen",
  "delete_phrase_confirmation": "Sind Sie sicher, dass Sie diesen Satz löschen möchten?",
  "delete_review": "Bewertung löschen",
  "delete_review_confirmation": "Möchten Sie Ihre Bewertung wirklich löschen?",
  "delete_roleplay": "Rollenspiel löschen",
  "delete_roleplay_confirmation": "Sind Sie sicher, dass Sie dieses Rollenspiel löschen möchten?",
  "delete_section": "Abschnitt löschen",
  "delete_section_confirmation": "Möchten Sie diesen Abschnitt wirklich löschen?",
  "delete_topic": "Thema löschen",
  "delete_topic_confirmation": "Möchten Sie dieses Thema wirklich löschen?",
  "description": "Beschreibung",
  "difficulty": "Schwierigkeit",
  "difficulties": "Schwierigkeiten",
  "disable": "Deaktivieren",
  "disabled": "Behindert",
  "display": "Anzeige",
  "display_classroom_code": "Display classroom code",
  "download_csv_file": "Herunterladen",
  "drop_csv_file_or_click_to_upload": "Löschen Sie die CSV-Datei oder klicken Sie zum Hochladen.",
  "edit": "Bearbeiten",
  "edit_bot": "Chatbot bearbeiten",
  "edit_discussion": "Diskussion bearbeiten",
  "edit_roleplay": "Rollenspiel bearbeiten",
  "email": "Email",
  "enable": "Aktivieren",
  "enabled": "aktiviert",
  "enrolment_key": "Registrierungsschlüssel",
  "enrolment_key_not_valid": "Registrierungsschlüssel ungültig",
  "enter_private_key": "Geben Sie den privaten Schlüssel ein",
  "error_generating_discussion": "Beim Erstellen der Diskussion ist ein Problem aufgetreten",
  "exercise": "Übung",
  "exercise_complete": "Übung abgeschlossen",
  "exercise_completed_icon": "{{name}} {{counter}}-mal abgeschlossen",
  "exercise_completion": "absolvierte die {{exercise}} '{{id}}'",
  "exercise_in_progress": "begann die {{exercise}} '{{id}}'",
  "exercise_info": "Übungsinfo",
  "exercise_no_longer_available": "Diese Übung ist nicht mehr verfügbar",
  "exercises": "Übungen",
  "exercises_completed": "Übungen abgeschlossen",
  "exercises_completed_icon": "{{name}} {{counter}}-mal abgeschlossen",
  "exit": "Beenden",
  "expand": "Aufklappen",
  "fill_in_contact_form": "Füllen Sie das unten stehende Formular aus",
  "find_bot": "Chatbot finden",
  "find_classroom": "Klassenzimmer finden",
  "find_course": "Kurs finden",
  "find_roleplay": "Rollenspiel finden",
  "finish": "Fertig",
  "finish_exercise": "Übung beenden",
  "for_lang": "ich spreche",
  "formatting_options": "Formatierungsoptionen",
  "from": "Von",
  "fullscreen": "Vollbild",
  "generate_definitions_info": "Erstelle Definitionen für die Ausdrücke in dieser Liste.",
  "generating": "Wird erstellt",
  "get_started": "Loslegen",
  "go_back": "Geh zurück",
  "go_back_to_topic": "Gehe zurück zum Thema",
  "go_to": "Go to",
  "go_to_settings": "Zu den Einstellungen",
  "group_information_form_title": "Erzähle uns von deiner Gruppe",
  "group_member_limit": "Maximale Mitgliederzahl",
  "group_name": "Gruppenname",
  "group_picture": "Gruppenbild",
  "group_subscription_form_title": "Gruppenabonnement einrichten",
  "help": "Hilfe",
  "hidden": "Ausgeblendet",
  "hide": "Ausblenden",
  "hide_bot": "Chatbot verstecken",
  "hide_chatbots_exercise": "Chatbots verstecken",
  "hide_listening_exercise": "Hörübung ausblenden",
  "hide_menu": "Menü ausblenden",
  "hide_options": "Optionen ausblenden",
  "hide_pronunciation_exercise": "Ausspracheübung ausblenden",
  "hide_roleplay": "Rollenspiel ausblenden",
  "hide_roleplays_exercise": "Rollenspiele ausblenden",
  "hide_section": "Abschnitt ausblenden",
  "hide_topic": "Thema ausblenden",
  "hide_translation_exercise": "Übersetzungsübung ausblenden",
  "hide_word_bank": "Word Bank ausblenden",
  "home": "Zuhause",
  "how_to_join_find_button": "Suche die Schaltfläche {{button}} und klicke darauf.",
  "how_to_join_get_ready": "Mach dich bereit zum Spielen.",
  "how_to_join_intro": "Führe die folgenden Schritte aus, um dem Spiel beizutreten:",
  "how_to_join_open_classroom": "Öffne den Kursraum {{classroom}} oder scanne den QR-Code unten",
  "how_to_join_sign_in": "Melde dich in deinem Konto an.",
  "how_to_join_title": "So trittst du dem Spiel bei",
  "in_game": "Im Spiel",
  "in_progress": "Continue jogando",
  "incorrect": "Falsch",
  "insert_bold": "Fett einfügen",
  "insert_italic": "Kursiv einfügen",
  "insert_link": "Link einfügen",
  "insert_photo": "Foto einfügen",
  "instruction_message": "Anleitung",
  "join": "Beitreten",
  "join_classroom": "Treten Sie dem Klassenzimmer bei",
  "join_code_desc": "Die Schüler können den folgenden Code verwenden, um sich anzumelden",
  "join_course": "Am Kurs teilnehmen",
  "join_date": "Beitrittsdatum",
  "joined": "Trat bei",
  "joined_classroom": "Klassenzimmer beigetreten",
  "joined_course": "Kurs beigetreten",
  "language": "Sprache",
  "language_phrase": "{{language}} Phrase",
  "language_translation": "{{language}}-Übersetzung",
  "learn": "Lernen",
  "learn_for_speakers_of": "{{learnLang}} für {{forLang}} Sprecher",
  "learn_lang": "ich will lernen",
  "leave_classroom": "Klassenzimmer verlassen",
  "leave_classroom_confirmation": "Möchten Sie dieses Klassenzimmer wirklich löschen?",
  "leave_course": "Kurs verlassen",
  "leave_course_confirmation": "Sind Sie sicher, dass Sie diesen Kurs verlassen möchten?",
  "left_classroom": "Linkes Klassenzimmer",
  "left_course": "Kurs verlassen",
  "lets_begin": "Lass uns anfangen",
  "library": "Bibliothek",
  "link_name": "Linkname",
  "link_name_helper_text": "Geben Sie einen Anzeigenamen für Ihren Link ein",
  "link_value": "URL verknüpfen",
  "link_value_helper_text": "Geben Sie die URL für Ihren Link ein",
  "listen_to_this_phrase": "Hör dir diesen Ausdruck auf {{language}} an!",
  "listener_dialog_desc": "Wählen Sie unten eine Stimme, um die Aussprache zu hören",
  "listening": "Hören",
  "listening_exercise_desc": "Können Sie aufnehmen, was gesagt wird?",
  "load_more_events": "Weitere Ereignisse laden",
  "loading": "Wird geladen",
  "loading_topics": "Themen werden geladen",
  "logout": "Ausloggen",
  "manage_course": "Kurs verwalten",
  "members": "Schüler",
  "members_not_found": "Nessun membro",
  "members_not_found_desc": "Es wurden keine Mitglieder gefunden",
  "message": "Chatbotschaft",
  "method": "Methode",
  "missing_details": "Fehlende Details",
  "more_definitions": "Weitere Definitionen",
  "more_options": "Mehr Optionen",
  "more_translations": "Weitere Übersetzungen",
  "my_courses": "Meine Kurse",
  "name": "Name",
  "new": "Neu",
  "next": "Nächster",
  "next_with_progress": "Nächster ({current} von {total})",
  "no_activity_found": "Keine Aktivität gefunden",
  "no_chatbot_templates": "Keine Vorlagen verfügbar",
  "no_courses_found": "Keine Kurse gefunden",
  "no_phrases": "Keine Ausdrücke",
  "no_topics_available": "Keine Themen verfügbar",
  "not_in_game": "Nicht im Spiel",
  "nualang_templates": "Vorlagen",
  "nudge_add_family_name_field_desc": "Gib deinen Nachnamen an, damit deine Lehrkräfte dich zuordnen können.",
  "nudge_add_family_name_profile_desc": "Füge deinen Nachnamen zu deinem Profil hinzu, damit deine Lehrkräfte dich zuordnen können.",
  "nudge_add_family_name_title": "Nachname hinzufügen",
  "on": "am",
  "only_available_on_chrome": "Nur auf Chrome verfügbar",
  "open_image_library": "Bildbibliothek öffnen",
  "open_in_google_sheets": "In Google Sheets öffnen",
  "open_search_student_name_filters": "Open search student name filters",
  "optional": "Optional",
  "or_choose_from_one_of_the_following": "Oder wählen Sie eine der folgenden Möglichkeiten",
  "percentage_complete": "Percentage Complete",
  "perfect_click_finish_create_group": "Perfekt! Klicke auf Fertigstellen, um deine Gruppe zu erstellen.",
  "phrase": "Phrase",
  "phrase_group_game_in_progress_icon": "{{name}} läuft",
  "phrase_lists_error": "Beim Laden der Ausdruckslisten ist ein Problem aufgetreten",
  "phrases": "Sätze",
  "player": "Spieler",
  "players": "Spieler",
  "plays": "{{number}} Spiele",
  "please_select_a_textfield": "Bitte wähle ein Textfeld aus",
  "popular_courses": "Beliebte Kurse",
  "preview": "Vorschau",
  "preview_pdf": "PDF-Vorschau",
  "previous": "Bisherige",
  "print": "Drucken",
  "private": "Privat",
  "problem": "Es gab ein Problem",
  "problem_creating": "Es gab ein Problem beim Erstellen",
  "problem_deleting": "Beim Löschen ist ein Problem aufgetreten",
  "problem_getting_reply": "Es gab ein Problem beim Erhalten der Antwort",
  "problem_loading": "Beim Laden ist ein Problem aufgetreten",
  "problem_sending_contact_form": "Problem beim Senden des Kontaktformulars",
  "profile": "Profil",
  "profiles": "Profile",
  "progress_icon": "Fortschrittssymbol",
  "pronounce_this_phrase": "Sprich deutlich!",
  "pronunciation": "Aussprache",
  "pronunciation_exercise_desc": "Übe das Aussprechen von Phrasen",
  "public": "Öffentlichkeit",
  "question": "Frage",
  "new_question_placeholder": "Geben Sie hier Ihre Frage ein",
  "questions": "Fragen",
  "quit": "Verlassen",
  "recommended": "Empfohlen",
  "record_message": "Nachricht aufzeichnen",
  "record_unsupported": "Aufnahme wird in diesem Browser nicht unterstützt",
  "records": "Aufzeichnungen",
  "redo_action": "Wiederholen",
  "refresh": "Aktualisieren",
  "remove": "Entfernen",
  "remove_bot": "Chatbot entfernen",
  "remove_card": "Remove Card",
  "remove_roleplay": "Rollenspiel entfernen",
  "remove_classroom_member": "Remove Classroom Student",
  "remove_classroom_member_confirmation": "Are you sure you want to remove this student from your classroom",
  "remove_member": "Remove Student",
  "member_removed_from_classroom": "Student removed from classroom",
  "reply": "Antworten",
  "reply_options": "Antwortoptionen",
  "reply_options_are_disabled": "Antwortoptionen sind deaktiviert",
  "reply_options_desc": "Ermöglichen Sie den Schülern, die richtige Antwort aus einer Liste von Optionen auszuwählen",
  "report_views": "Views",
  "required_for_private_classrooms": "Erforderlich für private Klassenzimmer",
  "required_for_private_courses": "Erforderlich für Privatkurse",
  "reset": "zurücksetzen",
  "restart_exercise": "Übung neu starten",
  "result": "Ergebnis",
  "retry": "Erneut versuchen",
  "return_to_course": "Zurück zum Kurs",
  "review_content": "Überprüfen Sie den Inhalt",
  "review_title": "Titel der Bewertung",
  "reviews": "Bewertungen",
  "reviews_not_found": "Keine Bewertungen",
  "reviews_not_found_desc": "Es wurden keine Bewertungen gefunden",
  "roleplay": "Rollenspiel",
  "roleplay_exercise_desc": "Simulieren und beantworten Sie Fragen zu Gesprächen zwischen zwei Personen",
  "roleplay_not_found": "Szenario nicht gefunden",
  "roleplay_not_found_desc": "Wir konnten dieses Szenario nicht finden. Möglicherweise wurde es gelöscht oder auf privat gesetzt.",
  "roleplays_not_found_desc": "Versuchen Sie, Ihre Suchparameter zu ändern",
  "roleplay_information": "Informationen zum Rollenspiel",
  "roleplay_name": "Rollenspielname",
  "roleplay_settings": "Rollenspieleinstellungen",
  "roleplays": "Rollenspiele",
  "save_changes": "Änderungen speichern",
  "save_definitions_error": "Beim Speichern der Definitionen ist ein Problem aufgetreten",
  "save_progress": "Fortschritt speichern",
  "scenarios": "Szenarien",
  "schedule": "Planen",
  "script_not_found": "Skript nicht gefunden",
  "script_not_found_desc": "Wir konnten dieses Skript nicht finden. Möglicherweise wurde es gelöscht oder auf privat gesetzt.",
  "search_images": "Bilder suchen",
  "see_more_pronunciations": "Weitere Aussprachen ansehen",
  "send": "Senden",
  "show_phrase_list": "Ausdrucksliste anzeigen",
  "show_progress": "Fortschritt anzeigen",
  "script": "Skript",
  "search": "Suchen",
  "search_for_student": "Suche nach Schüler",
  "section": "Sektion",
  "section_name": "Abteilungsname",
  "sections_not_found": "Keine Abschnitte gefunden",
  "sections_not_found_desc": "",
  "select_a_template": "Wählen Sie eine Vorlage aus",
  "select_file": "Datei aussuchen",
  "select_file_desc": "Legen Sie die Datei hier ab oder klicken Sie, um Ihren Computer zu durchsuchen",
  "select_files": "Dateien auswählen",
  "select_the_from_date": "Wählen Sie das Von-Datum aus",
  "select_the_to_date": "Wählen Sie das Bis-Datum aus",
  "settings": "die Einstellungen",
  "share": "Teilen",
  "share_via": "Teilen per",
  "show_bot": "Chatbot anzeigen",
  "show_chatbots_exercise": "Chatbots anzeigen",
  "show_listening_exercise": "Hörübung zeigen",
  "show_menu": "Zeige das Menü",
  "show_options": "Optionen anzeigen",
  "show_pronunciation_exercise": "Ausspracheübung anzeigen",
  "show_roleplay": "Rollenspiel zeigen",
  "show_roleplays_exercise": "Rollenspiele anzeigen",
  "show_section": "Abschnitt anzeigen",
  "show_topic": "Thema anzeigen",
  "show_translation_exercise": "Übersetzungsübung anzeigen",
  "skip": "Überspringen",
  "skip_copy_topic": "Überspringen",
  "speakers_of": "Sprecher von",
  "start": "Start",
  "start_course": "Kurs starten",
  "stop": "Halt",
  "stop_recording": "Höre auf, aufzunehmen",
  "student_instructions": "Anweisungen für Schüler",
  "student_instructions_placeholder": "Anweisungen für Schüler:\nSie können Ihre formatierte Anweisungsnachricht hier hinzufügen \n\ne.g. \"Willkommen beim Chatbot, Sie können beginnen, indem Sie Hallo eingeben \"",
  "student_limit": "Maximale Anzahl Lernender",
  "subject": "Gegenstand",
  "submit": "Absenden",
  "submitting": "Wird gesendet",
  "subscription": "Abonnement",
  "subscription_period_end": "Ende des Abrechnungszeitraums",
  "subscription_status": "Abonnementstatus",
  "substitution_desc": "Nehmen Sie Änderungen an der Nachricht des Benutzers vor, bevor Sie die Auslöser überprüfen.",
  "substitution_name": "Original Text",
  "substitution_name_helper_text": "Der Originaltext, der möglicherweise in der Nachricht des Benutzers enthalten ist",
  "substitution_value": "Ersatztext",
  "substitution_value_helper_text": "Sollte keine speziellen Symbole oder Satzzeichen enthalten und sollte auch in Kleinbuchstaben geschrieben sein",
  "substitutions": "Auswechslungen",
  "table": "Tabelle",
  "thank_you_for_submitting": "Vielen Dank für Ihre Einsendung. Wir werden uns so schnell wie möglich mit Ihnen in Verbindung setzen. Zurück zur Startseite",
  "the_default_topic_is_random": "Das Standardthema ist zufällig",
  "to": "Zu",
  "toggle_theme": "Hell / Dunkel-Thema umschalten",
  "toggle_light": "Toggle light theme",
  "toggle_dark": "Toggle dark theme",
  "topic": "Thema",
  "topic_code": "Themencode",
  "topic_desc": "Wenn sich ein Benutzer in einem Thema befindet, kann er nur Trigger abgleichen, die zu diesem Thema gehören.",
  "topic_image": "Themenbild",
  "topic_information": "Themeninformationen",
  "topic_name": "Themenname",
  "topic_not_found": "Thema nicht gefunden",
  "topic_not_found_desc": "Dieses Thema wurde möglicherweise gelöscht",
  "topics": "Themen",
  "translate": "Übersetzen",
  "translate_is_disabled": "Übersetzen ist deaktiviert",
  "translate_this_phrase": "Übersetz diesen Ausdruck!",
  "translation": "Übersetzung",
  "translation_exercise_desc": "Testen Sie Ihre Sprachkenntnisse, indem Sie Sätze übersetzen",
  "translations": "Übersetzungen",
  "trigger_value": "Text auslösen",
  "trigger_value_helper_text": "Sollte keine speziellen Symbole oder Satzzeichen enthalten und sollte auch in Kleinbuchstaben geschrieben sein",
  "triggers": "Löst aus",
  "triggers_desc": "Ein Trigger ist eine Textzeile, die verwendet wird, um mit der Nachricht des Benutzers übereinzustimmen.",
  "type": "Art",
  "unarchive": "Aus dem Archiv holen",
  "undo_action": "Rückgängig machen",
  "update": "Aktualisieren",
  "update_image": "Bild aktualisieren",
  "update_link": "Link aktualisieren",
  "update_phrase": "Phrase aktualisieren",
  "update_phrase_desc": "Nehmen Sie Änderungen an dieser vorhandenen Phrase vor",
  "update_picture": "Bild aktualisieren",
  "update_question": "Frage aktualisieren",
  "update_question_desc": "Stellen Sie eine Verständnisfrage. Die Frage kann mehrere richtige Antworten haben.",
  "update_recording_error": "Beim Aktualisieren der Aufnahme ist ein Problem aufgetreten",
  "update_review": "Update Review",
  "update_review_desc": "Update Review Beschreibung",
  "update_section": "Abschnitt aktualisieren",
  "update_section_desc": "Es liegt an Ihnen, wie Sie den Kurs strukturieren. Beispielstrukturen sind 'Anfänger, Mittelstufe, Fortgeschrittene' oder 'Woche 1, Woche 2, Woche 3'.",
  "update_substitution": "Substitution aktualisieren",
  "update_topic": "Thema aktualisieren",
  "update_trigger": "Trigger aktualisieren",
  "update_variable": "Variable aktualisieren",
  "upgrade": "Upgrade",
  "upload_phrases": "Sätze hochladen",
  "upload_phrases_desc": "Erstellen Sie eine CSV-Datei und laden Sie sie wie im folgenden Beispiel hoch.",
  "upload_phrases_example_phrase_1": "hallo",
  "upload_phrases_example_phrase_2": "auf Wiedersehen",
  "upload_phrases_example_phrase_3": "mein Name ist",
  "upload_phrases_example_definition_1": "Ein Wort, das man verwendet, um jemanden zu begrüßen",
  "upload_phrases_example_definition_2": "Ein Wort, das man verwendet, wenn man sich verabschiedet",
  "upload_phrases_example_definition_3": "Ein Satz, mit dem man jemandem seinen Namen mitteilt",
  "upload_script": "Skript Hochladen",
  "upload_script_desc": "Laden Sie ein Rollenspielskript mit einer CSV-Datei in dem unten gezeigten Format hoch",
  "use_keyboard": "Verwenden Sie die Tastatur",
  "use_word_bank": "Verwenden Sie Word Bank",
  "user_message": "Benutzermeldung",
  "user_updated": "Benutzer aktualisiert",
  "variable_desc": "Informationen, die in Ihrem Chatbot verwendet werden können.",
  "variable_name": "Variablennamen",
  "variable_value": "Variabler Wert",
  "variables": "Variablen",
  "vars": "Variablen",
  "view_activity": "Aktivität anzeigen",
  "view_instruction_message": "Anweisungen anzeigen",
  "view_outline": "Gliederung anzeigen",
  "view_progress": "Fortschritt anzeigen",
  "visibility": "Sichtweite",
  "visit_learning_site": "Learning Site besuchen",
  "voice_speed_disabled": "Die Sprechgeschwindigkeit ist für diese Stimme nicht verfügbar",
  "weekly_progress": "Wöchentlicher Fortschritt",
  "what_do_you_hear": "Was hörst du?",
  "answer_method": "Antwortmethode",
  "answers": "Antworten",
  "attempt_info": "Info versuchen",
  "bot_outputs": "Chatbot-Ausgänge",
  "creator_instructions": "Anweisungen für Lehrer",
  "creator_instructions_placeholder": "Sie können hier eine formatierte Anweisungsnachricht für einen Kursmitarbeiter hinzufügen, z. Willkommen beim Chatbot. Hier erfahren Sie, wie Sie Ihre Schüler anpassen können ...",
  "date": "Datum",
  "fri": "Fr.",
  "listener": "Hörer",
  "mon": "Mo.",
  "new_bots": "Neue Chatbots",
  "new_courses": "Neue Kurse",
  "new_roleplays": "Neue Rollenspiele",
  "no_results_found": "keine Ergebnisse gefunden",
  "option": "Möglichkeit",
  "play_again": "Nochmal abspielen",
  "role_played": "Rolle gespielt",
  "sat": "Sa.",
  "show_word_bank": "Wortbank anzeigen",
  "skipped": "Übersprungen",
  "speak": "Sprechen",
  "sun": "Sonne",
  "text": "Text",
  "thu": "Do.",
  "time": "Zeit",
  "time_spent": "Zeitaufwand",
  "tue": "Di.",
  "view_report": "Zeige Bericht",
  "voice": "Stimme",
  "wed": "Heiraten",
  "word_bank": "Wortbank",
  "teach": "Lehren",
  "active_now": "Jetzt aktiv",
  "manage_classroom": "Klassenzimmer verwalten",
  "must_question_least_correct_answer": "Muss eine Frage und mindestens eine richtige Antwort sein.",
  "enter_name_your_voice_clip": "Geben Sie einen Namen für Ihren Sprachclip ein?",
  "my_unnamed_clip": "Mein unbenannter Clip",
  "are_you_sure": "Bist du sicher?",
  "is_already_created_variable_overwrite": "ist bereits eine erstellte Variable, möchten Sie diese überschreiben?",
  "is_already_created_substitution_overwrite": "ist bereits eine erstellte Substitution, möchten Sie diese überschreiben?",
  "is_already_created_alternative_overwrite": "ist bereits eine erstellte Alternative, möchten Sie diese überschreiben?",
  "is_already_created_topic_overwrite": "ist bereits ein erstelltes Thema, möchten Sie es überschreiben?",
  "bring_your_bot_picture_name": "Erwecken Sie Ihren Chatbot zum Leben, indem Sie ihm ein Bild und einen Namen geben",
  "perfect_click_finish_create_bot": "Perfekt. Klicken Sie auf Fertig stellen, um Ihren neuen Chatbot zu erstellen",
  "lets_start_with_some_information_about_your_bot": "Beginnen wir mit einigen Informationen über Ihren Chatbot",
  "lets_start_some_information_about_classroom": "Beginnen wir mit einigen Informationen über Ihr Klassenzimmer",
  "the_language_classroom_teach": "Die Sprache, die in diesem Klassenzimmer unterrichtet wird",
  "the_language_students_classroom_speak": "Die Sprache, die die Schüler dieses Klassenzimmers sprechen",
  "limit_access_classroom_visibility_private_including_enrolment_key": "Beschränken Sie den Zugriff auf Ihr Klassenzimmer, indem Sie die Sichtbarkeit auf privat setzen und einen Registrierungsschlüssel hinzufügen",
  "add_collaborators": "Fügen Sie Mitarbeiter hinzu",
  "perfect_click_finish_create_classroom": "Perfekt. Klicken Sie auf Fertig stellen, um Ihr neues Klassenzimmer zu erstellen",
  "perfect_click_finish_create_course": "Perfekt. Klicken Sie auf Fertig stellen, um Ihren neuen Kurs zu erstellen",
  "lets_start_information_about_course": "Beginnen wir mit einigen Informationen zu Ihrem Kurs",
  "the_language_course_teach": "Die Sprache, die dieser Kurs unterrichten wird",
  "the_language_students_course_speak": "Die Sprache, die die Kursteilnehmer sprechen",
  "limit_access_course_setting_visibility_private_including_enrolment_key": "Beschränken Sie den Zugriff auf Ihren Kurs, indem Sie die Sichtbarkeit auf privat setzen und einen Registrierungsschlüssel hinzufügen",
  "selected": "Ausgewählt",
  "perfect_click_finish_create_roleplay": "Perfekt. Klicken Sie auf Fertig stellen, um Ihr neues Rollenspiel zu erstellen",
  "lets_start_with_information_about_roleplay": "Beginnen wir mit einigen Informationen zu Ihrem Rollenspiel",
  "invite": "Einladen",
  "topic_settings": "Themeneinstellungen",
  "topic_title": "Topic Title",
  "unanswered_table": "Unbeantwortet",
  "create_roleplay": "Rollenspiel erstellen",
  "roleplays_not_found_title": "Rollenspiele nicht gefunden",
  "play": "abspielen",
  "delete": "Löschen",
  "delete_picture": "Foto löschen",
  "use_wordbank_if_stuck": "Verwenden Sie die Wortbank, wenn Sie Hilfe benötigen",
  "play_bot_error": "Hoppla! Beim Chatbot ist ein Problem aufgetreten. Bitte versuchen Sie es erneut",
  "bot_editor_preview_error": "Ein Fehler ist aufgetreten. Unter https://nualang.com/guides/create-a-bot finden Sie eine Anleitung zum Erstellen eines Chatbots",
  "manage_courses": "Kurse verwalten",
  "refresh_courses": "Kurse aktualisieren",
  "customize_appearance_of_course": "Passen Sie das Erscheinungsbild des Kurses an",
  "customize_appearance_of_classroom": "Passen Sie das Erscheinungsbild des Klassenzimmers an",
  "customize_appearance_of_topic": "Customize the appearance of the topic",
  "create_duplicate": "Duplikat erstellen",
  "section_visibility": "Abschnitt Sichtbarkeit",
  "choose_a_language": "Wähle eine Sprache",
  "play_bot": "Chatbot spielen",
  "lets_find_a_template": "Lassen Sie uns eine Vorlage finden!",
  "search_by_difficulty": "Suche nach Schwierigkeitsgrad",
  "search_using_keywords": "Suche mit Schlüsselwörtern",
  "select_a_nualang_template": "Wählen Sie eine Nualang-Vorlage",
  "select_a_nualang_template_desc": "Vom Nualang-Team erstellte Vorlagen für den Einstieg.",
  "or_select_a_community_template": "Oder wählen Sie eine Community-Vorlage aus",
  "or_select_a_community_template_desc": "Community-Vorlagen werden von Lehrern auf der ganzen Welt erstellt.",
  "dashboard_welcome": "Willkommen, {{name}}!",
  "dashboard_welcome_desc": "Machen Sie sich mit dem Dashboard vertraut. Hier finden Sie einige Möglichkeiten, um loszulegen.",
  "enter_course_code": "Geben Sie einen Kurscode ein",
  "enter_course_code_desc": "Wenn Sie einen Kurscode haben, geben Sie diesen hier ein.",
  "enter_classroom_code": "Geben Sie einen Klassencode ein",
  "enter_classroom_code_desc": "Wenn Sie einen Klassencode haben, geben Sie diesen hier ein.",
  "search_nualang": "Entdecken Sie Nualang",
  "search_nualang_desc": "Es gibt eine wachsende Gemeinschaft gleichgesinnter Lehrer, die Gespräche mit unseren Nualas führen, sodass es immer etwas Neues zu lernen gibt.",
  "create_nualang": "Erstelle dein eigenes",
  "create_nualang_desc": "Erstellen Sie Gespräche und Sprachlektionen.",
  "roleplay_editor_welcome": "Erste Schritte mit dem Rollenspiel-Editor",
  "roleplay_editor_options": "Wähle eine Option",
  "roleplay_editor_options_desc": "Wählen Sie eine Nuala, um eine neue Zeile hinzuzufügen, oder fügen Sie eine Verständnisfrage hinzu.",
  "roleplay_editor_share": "Rollenspiel teilen",
  "roleplay_editor_play": "Rollenspiel spielen",
  "bot_editor_welcome": "Erste Schritte mit dem Chatbot-Editor",
  "bot_editor_sidebar": "Editor-Seitenleiste",
  "bot_editor_sidebar_desc": "In der Seitenleiste können Sie Änderungen an Ihrem Chatbot vornehmen.",
  "bot_editor_flow_chart": "Chatbot Flow",
  "bot_editor_flow_chart_desc": "Der Chatbot-Flow zeigt eine Übersicht über Ihren Chatbot und gibt eine Vorschau darauf, wie jede Nachricht aussehen wird.",
  "bot_editor_share": "Chatbot teilen",
  "bot_editor_play": "Chatbot spielen",
  "play_roleplay": "Rollenspiel spielen",
  "delete_script_item": "Element aus dem Skript löschen",
  "delete_script_item_confirmation": "Möchten Sie dieses Element wirklich aus dem Skript löschen?",
  "add_message": "Nachricht hinzufügen",
  "resources": "Ressourcen",
  "contact": "Kontakt",
  "sign_in": "Einloggen",
  "sign_up": "Anmelden",
  "faqs": "FAQs",
  "guides": "Tutorials",
  "back_to_app": "Zurück zur App",
  "notes": "Notizen",
  "notes_placeholder": "Geben Sie hier Notizen ein",
  "get_in_touch": "Kontakt",
  "get_in_touch_desc": "Haben Sie Fragen oder Feedback? Senden Sie uns eine Nachricht.",
  "avatar_generator": "Avatar Generator",
  "avatar_generator_desc": "Erstelle deinen persönlichen Avatar",
  "upload_image": "Bild hochladen",
  "upload_image_desc": "Bild per Drag & Drop von Ihrem Computer ziehen",
  "random": "zufällig",
  "done": "Erledigt",
  "file_size_exceeded": "Bild zu groß! Bitte laden Sie ein Bild hoch, das kleiner ist als ",
  "image_selection_failed": "Dieses Bild konnte nicht geladen werden. Bitte versuchen Sie ein anderes Bild oder laden Sie ein eigenes hoch.",
  "remove_course": "Kurs entfernen",
  "courses_joined": "Kurse verbunden",
  "classroom_courses_not_found_title": "Noch keine Kurse",
  "classroom_courses_not_found_desc": "Dieses Klassenzimmer hat noch keine Kurse.",
  "in_progress_activity": "In Bearbeitung",
  "bot_exercise_welcome": "Erste Schritte mit der Chatbot-Übung",
  "bot_exercise_restart": "Starten Sie den Chatbot neu!",
  "bot_exercise_keyboard_input": "Geben Sie es ein!",
  "bot_exercise_keyboard_input_desc": "Verwenden Sie die Tastatur, um eine Nachricht einzugeben. Wenn Sie Hilfe bei Sonderzeichen benötigen oder ein Emoji hinzufügen möchten, versuchen Sie es mit unseren hilfreichen Schaltflächen.",
  "bot_exercise_voice_input": "Sprich es!",
  "bot_exercise_voice_input_desc": "Klicken Sie auf das Mikrofon, um Ihre Stimme zu verwenden und Ihre Aussprache zu üben.",
  "bot_exercise_send_message": "Send it!",
  "bot_exercise_send_message_desc": "Senden Sie eine Nachricht an den Chatbot und starten Sie die Konversation.",
  "bot_exercise_audio_only_mic": "Sprich es!",
  "bot_exercise_audio_only_mic_desc": "Tippe auf das Mikrofon, um zu beginnen. Danach sprich einfach natürlich weiter — Nuala hört zu und antwortet automatisch für den Rest des Gesprächs.",
  "roleplay_exercise_welcome": "Erste Schritte mit der Rollenspielübung",
  "roleplay_exercise_read_script": "Lerne deine Zeilen!",
  "roleplay_exercise_read_script_desc": "Lesen Sie die Konversation und hören Sie zu, wie die Wörter ausgesprochen werden.",
  "roleplay_exercise_select_an_actor": "Wähle deine Rolle!",
  "roleplay_exercise_select_an_actor_desc": "Wählen Sie die Rolle aus, die Sie spielen möchten.",
  "roleplay_exercise_start": "Act it out!",
  "roleplay_exercise_start_desc": "Klicken Sie auf Start und spielen Sie mit Ihrer Tastatur oder Stimme die von Ihnen gewählte Rolle aus.",
  "listening_exercise_welcome": "Erste Schritte mit der Hörübung",
  "listening_exercise_speak": "Höre auf die Phrase!",
  "listening_exercise_speak_desc": "Klicken Sie hier, um zu hören, wie die Phrase ausgesprochen wird.",
  "listening_exercise_voice_options": "Höre eine andere Stimme!",
  "listening_exercise_voice_options_desc": "Hören Sie sich die Phrase an, die mit verschiedenen Stimmen gesprochen wird.",
  "listening_exercise_keyboard_input": "Geben Sie die Antwort ein!",
  "listening_exercise_keyboard_input_desc": "Verwenden Sie die Tastatur, um die Phrase einzugeben, die Sie hören.",
  "listening_exercise_word_bank": "Benötigen Sie Hilfe?",
  "listening_exercise_word_bank_desc": "Verwenden Sie die Wortbank, um die richtige Antwort auszuwählen.",
  "translation_exercise_welcome": "Erste Schritte mit der Übersetzungsübung",
  "translation_exercise_speak": "Höre auf die Phrase!",
  "translation_exercise_speak_desc": "Klicken Sie hier, um zu hören, wie die Phrase ausgesprochen wird.",
  "translation_exercise_read": "Lies den Satz!",
  "translation_exercise_read_desc": "Lesen Sie die zu übersetzende Phrase.",
  "translation_exercise_keyboard_input": "Geben Sie die Antwort ein!",
  "translation_exercise_keyboard_input_desc": "Verwenden Sie die Tastatur, um die Übersetzung einzugeben.",
  "translation_exercise_word_bank": "Benötigen Sie Hilfe?",
  "translation_exercise_word_bank_desc": "Verwenden Sie die Wortbank, um die richtige Antwort auszuwählen.",
  "pronunciation_exercise_welcome": "Erste Schritte mit der Ausspracheübung",
  "pronunciation_exercise_speak": "Höre auf die Phrase!",
  "pronunciation_exercise_speak_desc": "Klicken Sie hier, um zu hören, wie die Phrase ausgesprochen wird.",
  "pronunciation_exercise_read": "Lies den Satz!",
  "pronunciation_exercise_read_desc": "Lesen Sie die auszusprechende Phrase.",
  "pronunciation_exercise_voice_input": "Sprich die Phrase aus!",
  "pronunciation_exercise_voice_input_desc": "Klicken Sie auf das Mikrofon, um Ihre Stimme zu verwenden und Ihre Aussprache zu üben.",
  "exercise_share": "Mit anderen teilen!",
  "exercise_mute": "Den Ton stumm schalten!",
  "exercise_skip": "Skip!",
  "exercise_skip_desc": "Gehen Sie zum nächsten Satz, Sie können es am Ende erneut versuchen.",
  "exercise_restart": "Neustart!",
  "exercise_progress_bar": "Exercise progress bar",
  "what_would_you_like_to_do": "Was würdest du gern tun?",
  "i_want_to_learn": "Welche Sprache willst du lernen?",
  "i_want_to_teach": "Welche Sprache möchten Sie unterrichten?",
  "add_alternative_version": "Alternative Version hinzufügen",
  "language_translation_helper_text": "Drücken Sie die Eingabetaste, um die Übersetzung hinzuzufügen.",
  "change_roles": "Rolle wechseln?",
  "write_your_feedback_here": "Schreibe hier dein Feedback",
  "yes": "Ja",
  "you_are_human_check": "Bitte bestätige, dass du ein Mensch bist",
  "you_will_lose_your_progress_on_this_exercise": "Sie werden Ihre Fortschritte bei dieser Übung verlieren.",
  "confirm": "Bestätigen",
  "general": "Allgemeine",
  "shuffle_phrases": "Shuffle Phrasen",
  "shuffle_phrases_desc": "Randomisieren Sie die Reihenfolge Fragen werden in den Übungen gestellt.",
  "errors": "Fehler",
  "missing_translation": "Fehlende Übersetzung",
  "missing_phrase": "Fehlende Phrase",
  "invalid_image_domain": "Die Bild-URL muss von einer genehmigten Nualang-Domain stammen",
  "row": "Zeile",
  "no_valid_type": "Der Typ muss 'actor' oder 'question' sein.",
  "no_actor_text": "Kein Text für den Schauspieler",
  "no_actor_number": "Der Schauspieler muss am Ende eine Nummer haben, z. actor1, actor2",
  "no_question": "Keine Frage",
  "no_answers_provided": "Keine Antworten angegeben",
  "no_correct_answer_provided": "Kein korrekter Antwortanbieter",
  "no_answers": "Keine Antworten",
  "duplicate_topic": "Thema Duplizieren",
  "normal_mode": "Normaler Modus",
  "spreadsheet_mode": "Tabellenkalkulationsmodus",
  "image": "Bild",
  "delete_selected_row": "Ausgewählte Zeile löschen",
  "crop_image": "Bild zuschneiden",
  "crop": "Ernte",
  "zoom": "Zoomen",
  "rotate": "Drehen",
  "hide_preview": "Vorschau Ausblenden",
  "show_preview": "Vorschau Zeigen",
  "try_again": "Versuchen Sie es nochmal",
  "confidence_score": "Der Konfidenzprozentsatz gibt die Wahrscheinlichkeit an, dass die einzelnen Wörter richtig erkannt wurden.",
  "subscription_plan_teach": "Teach Plan",
  "subscription_plan_teacher_pro": "Teacher PRO",
  "subscription_plan_basic": "Teacher Basic",
  "subscription_plan": "Subscription Plan",
  "subscription_status_trialing": "Free Trial",
  "subscription_status_active": "Active",
  "subscription_status_canceled": "Canceled",
  "subscription_status_undefined": "Free",
  "status": "Status",
  "upgrade_plan": "Upgrade Plan",
  "manage_plan": "Manage Plan",
  "cancel_plan": "Cancel Plan",
  "your_plan": "Your Plan",
  "plan_cost": "Plan Cost",
  "next_billing_date": "Current Period End",
  "free": "Free",
  "payment_method": "Payment Method",
  "pricing_page_title": "Choose your plan",
  "pricing_page_subtitle": "Pricing plans for teachers, schools and districts.",
  "pricing_page_testimonials_title": "What Teachers are saying",
  "compare_plans": "Compare Plans",
  "features": "Features",
  "upgrade_submit": "Upgrade",
  "upgrade_subscription_desc": "To access this feature you need to upgrade your account. Click Upgrade to be taken to the pricing page.",
  "upgrade_plan_explanation": "To access this feature you need to upgrade your account.",
  "upgrade_subscription_student": "This feature is available to teachers only.",
  "public_visibility_disabled_wayside": "Klassenzimmer werden von Wayside Publishing verwaltet und müssen privat bleiben.",
  "public_visibility_disabled_loading": "Wir überprüfen noch Ihr Abonnement. Bitte aktualisieren Sie die Seite, falls sich nichts ändert.",
  "public_visibility_disabled_trial": "Öffentliche Klassenzimmer sind während einer kostenlosen Testphase nicht verfügbar. Führen Sie ein Upgrade auf einen kostenpflichtigen Plan durch, um dieses Klassenzimmer öffentlich zu machen.",
  "creator_not_subscribed": "This content is not joinable as the creator is not currently subscribed.",
  "first_name": "First Name",
  "last_name": "Last Name",
  "role": "Role",
  "school_name": "School Name",
  "school_district": "School District",
  "city": "City",
  "state": "State",
  "send_message": "Send Message",
  "sign_me_up": "Sign me up!",
  "free_trial": "FREE Trial",
  "interactive_demo": "Interactive Demo",
  "news_and_updates": "News and Updates",
  "teacher": "Teacher",
  "principal": "Principal",
  "tutor": "Tutor",
  "parent": "Parent",
  "student": "Student",
  "other": "Other",
  "none": "None",
  "group_subscription_plans": "Group Subscription Plans",
  "group_plan": "Group Plan",
  "leave_group": "Leave Group",
  "joined_subscription": "Joined subscription",
  "joined_subscription_desc": "Welcome to the {{groupName}} group subscription, you are now using Teacher PRO!",
  "unable_to_join_subscription": "Unable to join subscription",
  "unable_to_join_subscription_desc": "There was an issue joining subscription, please try again later.",
  "unable_to_join_subscription_invalid_email_desc": "You cannot join this group without having one of the allowed email domains: {{allowedDomains}}",
  "unable_to_join_subscription_limit_reached_desc": "'{{groupName}}' has reached it's student limit, contact the group admin to increase the limit.",
  "moderated_image_dialog": "Nualang detected an image that was inappropriate, unwanted, or offensive and blocked it to provide a safer user experience. Please try a different image.",
  "moderate_title": "Image Blocked",
  "recommended_courses": "Recommended Courses",
  "subscription_status_trialing_expired": "Free Trial Expired",
  "no_public_content_created": "No public content created",
  "add_tag": "Press enter / return key to add a tag",
  "add_collaborator_tag": "Press enter / return key to add a collaborator",
  "add_to_classroom": "Add to classrooms",
  "add_to_classroom_desc": "Add '{{courseName}}' to {{classroomNames}}.",
  "change_voice_speed": "Change the voice speed!",
  "extra_fast": "Super speed",
  "fast": "Very fast talker",
  "medium": "Normal speed",
  "slow": "Slow it down a bit",
  "extra_slow": "One word at a time",
  "card_ALL": "All",
  "join_classroom_to_access": "Join classroom to access",
  "join_course_to_access": "Join course to access",
  "confidence": "Confidence",
  "teach_lang": "I want to teach",
  "write_feedback": "Write Feedback",
  "allowed_domains": "Allowed school domains (optional)",
  "add_allowed_domains_desc": "Restrict access based on school domain e.g 'schooldomain.com'",
  "send_feedback": "Send Feedback",
  "add_feedback": "Add Feedback",
  "feedback_content": "Feedback Content",
  "report_problem": "Report problem",
  "report_problem_input_label": "Problem description",
  "update_feedback": "Update Feedback",
  "student_completes_exercise": "A student completes an exercise",
  "delete_feedback_confirmation": "Are you sure you want to delete this feedback?",
  "delete_feedback": "Delete Feedback",
  "updates_to_our_terms_of_service": "Updates to our Terms of Service",
  "email_me_when": "Email me when:",
  "new_classroom": "New Classroom",
  "student_progress": "Student Progress",
  "view_course": "View Course",
  "view_section": "View Section",
  "classroom_members_not_found_title": "No students yet",
  "classroom_members_not_found_desc": "This classroom does not have any students yet.",
  "open_topic": "Open Topic",
  "click_to_speak": "click to speak",
  "click_to_stop": "click to stop",
  "listening_indicator": "Listening ...",
  "save_recording_to_report": "Save recording to report",
  "no_voice_recording_saved": "Voice recording was not saved",
  "classrooms_not_created": "No classrooms selectable",
  "select_a_classroom": "Select a classroom",
  "voice_attempt": "Voice attempt",
  "upload_variables": "Upload variables",
  "next_game": "Next Game",
  "roleplay_games": "Roleplay Games",
  "roleplay_games_description": "Click on one of the cards below to play a specific game",
  "choose_game_mode": "Choose a game mode",
  "story": "Story",
  "story_description": "Listen to the conversation between the characters and answer questions to test your understanding.",
  "fill_in_blanks": "Fill in the blanks",
  "fill_in_blanks_description": "Can you correctly identify what's missing?",
  "fill_in_the_blanks": "Fill in the blanks",
  "fill_in_the_blanks_description": "Can you correctly identify what's missing?",
  "act_it_out": "Act it out",
  "act_it_out_description": "Can you select the correct response?",
  "act_it_out_listening": "Act it out - Listening",
  "act_it_out_listening_description": "Use your listening skills to select the correct response.",
  "act_it_out_speaking": "Act it out - Speaking",
  "act_it_out_speaking_description": "Practice your pronunciation by speaking your part.",
  "act_it_out_listening_speaking": "Act it out - Listening and Speaking",
  "act_it_out_listening_speaking_description": "Practice your pronunciation by speaking your part.",
  "select_role": "Select your role",
  "select_role_description": "Select the role you would like to play.",
  "mute": "Mute",
  "unmute": "Unmute",
  "replay": "Restart",
  "restart": "Restart",
  "group_courses": "Group courses",
  "select": "Select",
  "classroom_creator_welcome": "Getting started with your classroom",
  "classroom_creator_welcome_free_trial": "Welcome to your 30 day free trial of Nualang! To get you started, we have setup your first classroom.",
  "classroom_creator_add_courses": "Add courses",
  "classroom_creator_add_courses_desc": "Choose how you want to add courses to the classroom.",
  "classroom_creator_add_students_email": "Invite students",
  "classroom_creator_track_progress": "Track student activity",
  "classroom_creator_track_progress_desc": "Once students have joined the classroom, click to view their progress on the courses which have been added.",
  "forLang_and_learnLang_the_same": "Learn language and speaker language are the same. Translation exercise is disabled as a result",
  "english": "Englisch",
  "french": "Französisch",
  "german": "Deutsch",
  "irish": "Irisch",
  "italian": "Italienisch",
  "portuguese": "Portugiesisch",
  "spanish": "Spanisch",
  "close": "Schließen",
  "last": "Leisten",
  "classroom": "Klassenzimmer",
  "update_avatar": "Update Avatar",
  "update_avatar_desc": "Update your personal avatar",
  "invite_students": "Invite Students",
  "share_student_link_desc": "Share the instructions below to invite students to join.",
  "invite_link_desc": "Please sign in or create an account on Nualang by clicking this invite link:",
  "join_instructions_1": "This will bring you to the ",
  "join_instructions_2": "I created for you, where you'll have to click ‘Join’",
  "enrollment_key_text": "and input the key: ",
  "copy_student_instructions": "Copy student instructions",
  "or_invite_via": "Or invite via",
  "invite_email_subject": "Invitation to join a Nualang",
  "dear_students": "Dear Students",
  "dashboard": "Dashboard",
  "preview_roleplay": "Preview Roleplay",
  "roleplay_preview": "Preview",
  "roleplay_preview_decription": "Preview the full roleplay script",
  "sort": "Sort",
  "sort_by": "Sortieren nach",
  "newest": "Neueste",
  "alphabetical": "Alphabetisch",
  "recently_changed": "Kürzlich geändert",
  "recently_viewed": "Kürzlich angesehen",
  "oldest": "Älteste",
  "default": "Standard",
  "clear_filters": "Filter zurücksetzen",
  "member": "Student",
  "stop_speaking": "Stop Speaking",
  "agree_to_terms_and_conditions_1": "I agree to the ",
  "nualang_terms": "Nualang terms",
  "agree_to_terms_and_conditions_2": ", including acceptance of our ",
  "privacy_policy": "Privacy and Data Protection policy",
  "first_classroom_description": "This is a classroom to help students speak {{learnLang}} with confidence.",
  "upload": "Upload",
  "download": "Download",
  "classroom_creator_add_students_email_desc": "Click to explore different ways to invite students to your classroom.",
  "bot_sign_in_message": "You must be signed in to play this Chatbot",
  "course_sign_in_to_access": "Sign in to access this course",
  "have_an_account": "Have an account?",
  "provide_a_little_more_information": "Provide a little more information",
  "instructions": "Instructions",
  "close_preview": "Close Preview",
  "check_recognition": "Check speech recognition",
  "checking_recognition": "Checking speech recognition ...",
  "phrase_recognised": "Phrase recognised",
  "phrase_not_recognised": "Phrase not recognised",
  "speech_recognition_info": " Checking the speech recognition allows you to determine whether or not your students will have difficulty pronouncing this phrase in our exercises.",
  "speech_recognition_error_info": "We recognised your phrase as {{recognisedPhrase}}. We recommend that you reword the phrase and/or add an alternative version.",
  "my_library": "My Library",
  "add_own_exercise_message": "Create new {{exerciseName}} using templates created by you",
  "no_exercises_in_library": "There are no {{exerciseName}} created by you.",
  "classroom_invite_feature_disabled_message": "This feature is disabled because your students will be able to join this classroom automatically.",
  "skip_navigation": "Skip Navigation",
  "generate_roleplay": "Generate Roleplay",
  "choose_topic_for_roleplay": "Choose a topic for the roleplay",
  "roleplay_generated": "Roleplay Generated",
  "select_roleplay": "Select Roleplay",
  "chatgpt_roleplay_description": "This is a roleplay about {{topic}}",
  "check_answer": "Check Answer",
  "card": "Karte",
  "banner": "Banner",
  "load_more": "Load More",
  "bot_input_placeholder": "Use the keyboard to type a message",
  "bot_input_mobile_placeholder": "Type a message...",
  "audio_only_mode": "Hören & Sprechen",
  "audio_only_tooltip": "Zum reinen Audiomodus wechseln",
  "switch_to_text": "Zu Text wechseln",
  "switch_to_text_tooltip": "Zurück zum Textmodus wechseln",
  "audio_only_title": "Sprich mit {{botName}}",
  "audio_only_subtitle": "Ein rein gesprochenes Gespräch — kein Text. Kopfhörer empfohlen.",
  "audio_only_mode_unavailable_fallback_chat": "Diese Übung erfordert den Modus „Zuhören & Sprechen“, der auf diesem Gerät jedoch nicht verfügbar ist – es wird stattdessen im Chat-Modus fortgefahren.",
  "microphone_ready": "Mikrofon bereit",
  "bot_is_speaking": "Spricht...",
  "thinking_indicator": "Denkt nach...",
  "start_conversation": "Gespräch starten",
  "stop_button_label": "Stopp",
  "stop_bot_message": "Chatbot-Stimme stoppen",
  "choose_mode_text_option": "Chat",
  "choose_mode_text_option_desc": "Tippe oder sprich deine Antworten und lies oder höre die Antworten des Bots.",
  "bot_mode_in_progress_icon": "{{mode_name}} conversation currently in progress",
  "bot_mode_completed_icon": "{{mode_name}} completed {{counter}} time",
  "bot_modes_completed_icon": "{{mode_name}} completed {{counter}} times",
  "replay_button_label": "Wiederholen",
  "replay_bot_message": "Chatbot-Nachricht wiederholen",
  "you": "Du",
  "ready_when_you_are": "Bereit, wenn du es bist",
  "bot_speaking_banner": "{{botName}} spricht",
  "listening_to_you": "Hört dir zu",
  "bot_thinking_banner": "{{botName}} denkt nach",
  "one_moment": "Einen Moment",
  "listen_first": "Zuerst zuhören",
  "tap_when_done": "Tippen, wenn du fertig bist",
  "conversation_complete": "Gespräch abgeschlossen",
  "exchanges_label": "Wechsel",
  "time_spoken_label": "Sprechzeit",
  "review_your_turns": "Deine Beiträge ansehen",
  "submit_to_teacher": "An Lehrkraft senden",
  "great_job": "Gut gemacht!",
  "or": "oder",
  "choose_difficulty_of_roleplay": "Choose a difficulty for the roleplay",
  "child": "Child",
  "game_visibility": "Game Visiblity",
  "duplicate_course": "Duplicate Course",
  "amount_must_not_exceed_10": "Amount must not exceed 10",
  "amount_must_be_greater_than_0": "Amount must be greater than 0",
  "voice_pitch": "Voice Pitch",
  "voice_pitch_example": "Hallo, Mein Name ist {{name}}",
  "voice_pitch_disabled": "Adjusting the pitch is not possible for this voice.",
  "voice_pitch_x_low": "Very Low",
  "voice_pitch_low": "Low",
  "voice_pitch_medium": "Medium",
  "voice_pitch_high": "High",
  "voice_pitch_x_high": "Very High",
  "contact_us": "Contact Us",
  "contact_us_message": "Thank you for using Nualang. Please send your message below and we will get back to you at the earliest.",
  "expected_phrases": "Expected Phrases",
  "expected_phrases_info": "Phrases you expect your students to use during the exercise that you'd like to be recognised correctly when the student speaks. For example, if the exercise was about the weather you might want to recognise the word 'weather' more often than 'whether'",
  "add_expected_phrases": "Add Expected Phrases",
  "phrase_length_exceeded_error": "Phrase should not exceed 100 characters",
  "whats_new": "What's New",
  "wayside_subscription_message": "Your subscription is managed by Wayside Publishing",
  "select_the_correct_answer": "Select the correct answer",
  "pronunciation_score": "Pronunciation score",
  "pronunciation_score_explanation": "The pronunciation score is based on the number of words recognised correctly ({{transcriptCompletenessPercentage}}%) and how clearly they were recognised.",
  "add_course": "Add Course",
  "exercise_completed": "Exercise Completed",
  "exercise_not_completed": "Exercise Not Completed",
  "generate_roleplay_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "experimental_feature_desc": "New AI Feature - We would love to hear your feedback",
  "generating_roleplay": "Generating Roleplay",
  "updated": "Updated",
  "view_topic": "View Topic",
  "view_roleplay": "View Roleplay",
  "view_bot": "View Chatbot",
  "student_reports_problem": "A student reports a problem during an exercise",
  "problem_reported": "Problem reported",
  "remove_course_confirmation": "Are you sure you want to remove this course?",
  "classroom_member_limit_reached": "Classroom has reached its student limit",
  "upload_pdf": "Upload PDF",
  "remove_pdf": "Remove PDF",
  "classroom_updated": "Classroom Updated",
  "deleted": "Deleted",
  "created": "Created",
  "moderation_warning": "The following categories were detected in your uploaded image(s):",
  "warning": "Warning",
  "use_anyways": "Use Anyways",
  "view_pdf": "View Story",
  "schedule_discussion": "Schedule discussion",
  "video_chat": "Video Chat",
  "video_chat_member": "Video Chat Member",
  "create_meeting": "Create meeting",
  "group_assignment": "Group assignment",
  "join_group": "Join Group",
  "groups": "Groups",
  "group": "Group",
  "welcome": "Welcome",
  "delete_pdf": "Delete PDF",
  "delete_pdf_confirmation": "Are you sure you want to delete this PDF?",
  "course_updated": "Course updated",
  "overwrite_phrases": "Overwrite Phrases",
  "roleplay_game_in_progress_icon": "Roleplay game currently in progress",
  "roleplay_game_completed_icon": "Roleplay game has been completed {{counter}} time",
  "roleplay_games_completed_icon": "Roleplay game has been completed {{counter}} times",
  "page": "Page",
  "remove_group": "Gruppe Entfernen",
  "create_groups": "Gruppen erstellen",
  "select_all": "Alles auswählen",
  "unknown": "Unbekannt",
  "add_a_discussion_topic": "Diskussionsthema hinzufügen",
  "add_a_discussion_prompt": "Füge eine Diskussionsanregung hinzu",
  "add_a_url_for_students_to_discuss": "URL hinzufügen, über den die Studierenden diskutieren können",
  "images_that_students_can_use_as_a_background_during_the_call": "Bilder, die die Studierenden während des Anrufs als Hintergrund verwenden können",
  "discussion_images": "Diskussionsbilder",
  "images_for_students_to_discuss_during_the_call": "Bilder, über die die Studierenden während des Anrufs diskutieren können",
  "recording_time": "Recording Time",
  "due_date": "Fälligkeitsdatum Date",
  "record_time_limit": "Aufnahmezeitbegrenzung",
  "interculturarity": "Interkulturalität",
  "comprehensibility": "Verständlichkeit",
  "function_and_text_type": "Funktion und Texttyp",
  "vocabulary_in_context": "Vokabular im Kontext",
  "Drag_and_drop_image_from_your_computer": "Bild von Ihrem Computer ziehen und ablegen",
  "schedule_discussion_options": "Diskussionsoptionen planen",
  "chat_options": "Chat-Optionen",
  "recording_info": "Submission Info",
  "discussion_id": "Diskussions-ID",
  "discussion_prompt": "Diskussionsanregung",
  "attendees": "Teilnehmer",
  "created_discussions": "Erstellte Diskussionen",
  "grouped_discussions": "Gruppierte Diskussionen",
  "no_recordings_found": "Keine Aufnahmen gefunden",
  "recordings": "Aufnahmen",
  "scheduled_meetings": "Geplante Meetings",
  "no_meetings_scheduled": "Keine geplanten Meetings",
  "discussion_info": "Diskussionsinformationen",
  "invites": "Einladungen",
  "invited_members": "Eingeladene Mitglieder",
  "minute": "Minute",
  "feedback": "Feedback",
  "view": "Ansicht",
  "no_data_found": "Keine Daten Gefunden",
  "no_past_discussions_found": "Keine Vergangenen Diskussionen Gefunden",
  "no_submissions_found": "Keine Einreichungen Gefunden",
  "no_scheduled_discussions_found": "Keine Geplanten Diskussionen Gefunden",
  "view_more": "Mehr Anzeigen",
  "past": "Vergangenheit",
  "submissions": "Einreichungen",
  "background_images": "Hintergrundbilder",
  "no_conversation_available": "Keine Unterhaltung Verfügbar",
  "join_live_game": "Join Live Game",
  "live_game_medals": "Live-Spiel-Medaillen",
  "live_game_medals_description": "Schalte Medaillen frei, indem du beim Live-Spiel den 1., 2. oder 3. Platz belegst",
  "classroom_has_no_live_game": "Classroom currently has no live game",
  "speech_recognition_error_info_no_phrase": "We did not recognise your phrase. We recommend that you reword the phrase and/or add an alternative version.",
  "enrolment_key_min_chars": "Enrolment key must be at least 5 characters long",
  "zoom_in": "Zoom In",
  "zoom_out": "Zoom Out",
  "game_created": "Game created",
  "play_live": "Play Live",
  "play_live_desc": "Select the exercise you'd like to play live in the classroom.",
  "live_dialog_description": "Select the exercise you'd like to play live in the classroom.",
  "no_special_characters": "Cannot contain special characters",
  "required": "Required",
  "nuala_performance_rating": "Nuala Leistungsbewertung",
  "using_nuala_performance": "Wenn Sie die Nuala Leistungsbewertung verwenden, gehen alle manuell erstellten Bewertungen verloren.",
  "are_you_sure_nuala_performance": "Sind Sie sicher, dass Sie die Nuala Leistungsbewertung verwenden möchten?",
  "course_deletion_note": "*Note deleting this course will also delete the {{sectionCount}} section(s) in this course and its contents",
  "classroom_deletion_note": "*Note deleting this classroom will also delete the {{courseCount}} course(s) in this classroom and its contents",
  "topic_deletion_note": "*Note deleting this topic will also delete the {{phraseCount}} phrase(s), {{botCount}} Chatbot(s) and {{roleplayCount}} roleplay(s) in this topic and its contents",
  "section_deletion_note": "*Note deleting this section will also delete the {{topicCount}} topic(s) in this section and its contents",
  "confirmDeletionText": "To confirm deletion, type 'delete' into the field below",
  "subscription_status_cancelled": "Cancelled",
  "subscription_status_active expired": "Expired",
  "subscription_status_active_expired": "Expired",
  "leaderboard": "Leaderboard",
  "waiting_message": "Get ready, the game will start soon",
  "play_game": "Play Game",
  "close_game": "Close Game",
  "cancel_game": "Cancel Game",
  "end_game": "End Game",
  "games": "Games",
  "course_no_sections": "This course has no sections",
  "topic_no_phrases": "This topic has no phrases",
  "next_question": "Next question",
  "your_answer": "Your answer",
  "change_answer": "Change answer",
  "final_results": "Results",
  "game_ended": "Game ended",
  "joined_game": "Joined game",
  "equipment_problem_label": "Equipment problem",
  "equipment_problem_example": "e.g. My speaker or microphone is not working",
  "technical_problem_label": "Technical problem",
  "technical_problem_example": "e.g. The app is not working correctly",
  "content_problem_label": "Content problem",
  "content_problem_example": "e.g. I noticed a mistake in the exercise content",
  "end_question_early": "End Question Early",
  "discussion_topic": "Discussion Topic",
  "discussion_link": "Discussion Link",
  "scheduled": "Scheduled",
  "go_back_to_classroom": "Go back to Classroom",
  "discussion_created": "Diskussion Erstellt",
  "discussion_updated": "Diskussion aktualisiert",
  "give_feedback": "Feedback Geben",
  "nualang_live_welcome": "Welcome to Nualang Live!",
  "nualang_live_invite": "Invite Students",
  "nualang_live_invite_desc": "Click here to see how students join the game.",
  "nualang_live_game_members": "Game Members",
  "nualang_live_game_members_desc": "Click here to see who hasn't joined the game yet.",
  "nualang_live_start_game": "Start the game!",
  "nualang_live_settings": "Game Settings",
  "nualang_live_settings_desc": "Click here to see game options",
  "timer_length": "Timer Length",
  "keyboard_and_word_bank": "Keyboard and Word Bank",
  "keyboard_only": "Keyboard Only",
  "word_bank_only": "Word Bank Only",
  "answer_options": "Answer Options",
  "game_settings": "Game Settings",
  "create_feedback": "Create Feedback",
  "first_place": "First Place",
  "second_place": "Second Place",
  "third_place": "Third Place",
  "final_score": "Final Score",
  "no_discussions_found": "Keine Diskussionen gefunden",
  "no_discussions_found_desc": "Alle Diskussionen und Einreichungen können hier gefunden werden",
  "quality_of_interaction": "Qualität der Interaktion",
  "number_of_questions": "Number of Questions",
  "estimated_game_time": "Estimated Game Time",
  "minutes": "Minutes",
  "discuss": "Diskutieren",
  "open_live_game": "Open Live Game",
  "correct_answers": "Correct Answers",
  "game_has_ended": "This game has ended, please wait for a new Live Game.",
  "game_has_canceled": "This game has been canceled, please wait for a new Live Game.",
  "allow_wordBank": "Allow students to use the word bank in exercises",
  "creator_default": "Creator's default",
  "course_default": "Course default",
  "course_settings_description": "Adjust the learning experience for students of this classroom",
  "change_settings": "Change Settings",
  "choose_topic_from_pdf_for_roleplay": "Choose a topic for the roleplay based on context from the course pdf",
  "use_context_from_course_pdf": "Use context from course pdf",
  "use_context_from_course_pdf_info": "Turn this on to be able to generate a roleplay based on the contents of the course pdf if the  prompt is relevent to the contents in the pdf",
  "feedback_all_info": "Bietet Feedback an alle Mitglieder der Diskussionsgruppe. Sie können einem Schüler nicht gleichzeitig Gruppen- und individuelles Feedback geben.",
  "rubric_info_desc": "View the Analytic Growth Rubric, the criteria being used in our AI feedback.",
  "rubric_info": "Rubrik-Info",
  "listen_to_story": "Listen to the Story",
  "roleplay_no_interactions": "This roleplay has no interactions",
  "number_of_interactions": "Number of Interactions",
  "archive_title_submissions": "Archive Submissions",
  "archive_description_submissions": "Are you sure you want to archive the submissions?",
  "archive_title": "Archive Discussion",
  "archive_description": "Are you sure you want to archive this discussion? Students invites to this discussion will also be removed.",
  "discussion_templates": "Diskussionsvorlagen",
  "discussion_templates_desc": "Verwenden Sie eine unserer vordefinierten Diskussionsvorlagen, um Ihnen bei der Erstellung von Inhalten für Ihre Studierenden zu helfen",
  "find_courses": "Find Courses",
  "create_your_own": "Create Your Own ",
  "community_courses_description": "Find a course from the library for your students",
  "create_your_own_description": "Build a brand new course for your students",
  "empty_live_dialog_description": "Add a course if you'd like to play live in the classroom.",
  "no_classroom_to_join": "Your teacher has not setup their classroom on Nualang yet. Please ask them to do so, then try again.",
  "resume": "Resume",
  "pause": "Pause",
  "discuss_welcome": "Diskussionsanleitung",
  "discuss_scheduled_discussions": "Geplante Diskussionen",
  "discuss_scheduled_discussions_desc": "Hier finden Sie die geplanten Diskussionen, die vom Lehrer erstellt wurden. Sie können sich diesen Diskussionen anschließen und mit anderen Schülern Ihrer Gruppe über ein Thema sprechen.",
  "discuss_refresh_discussions": "Diskussionen aktualisieren",
  "discuss_refresh_discussions_desc": "Dieser Button ermöglicht es Ihnen, die neuesten geplanten Diskussionen zu aktualisieren.",
  "discuss_recorded_discussions": "Diskussionen aufzeichnen",
  "discuss_recorded_discussions_desc": "Hier finden Sie die Diskussionen, die Sie aufgezeichnet und dem Lehrer zur Überprüfung vorgelegt haben. Sobald Feedback gegeben wurde, können Sie es anzeigen.",
  "discuss_grouped_discussions": "Gruppierte Diskussionen",
  "discuss_grouped_discussions_desc": "Hier finden Sie alle Diskussionen, die Sie für Ihre Schüler basierend auf dem Themennamen erstellt haben. Klicken Sie auf eine gruppierte Diskussion, um zu sehen, welche Schülergruppen erstellt wurden.",
  "discuss_submissions": "Diskussionsbeiträge",
  "discuss_submissions_desc": "Hier finden Sie die aufgezeichneten Diskussionsbeiträge, die von Schülergruppen erstellt wurden. Sie können ihre Aufzeichnung sowie die Transkription der Diskussionen anzeigen und individuelles oder gruppiertes Feedback geben.",
  "refresh_discuss": "Diskussion Aktualisieren",
  "nuala_ai": "Nuala KI",
  "performance_ratings": "Leistungsbeurteilungen",
  "attended": "Anwesend",
  "did_not_attend": "Nicht teilgenommen",
  "discussion_attendance": "Teilnahme an Diskussionen",
  "submitted_recordings": "Eingereichte Aufnahmen",
  "invalid_date": "Invalid Date",
  "go_to_profile_settings": "Go to profile settings",
  "not_applicable": "Omit",
  "comprehension": "Comprehension",
  "feedback_text": "Feedback Text",
  "submit_feedback": "Submit Feedback",
  "select_students_to_group": "Select All Students",
  "created_groups": "Created Groups",
  "feedback_info": "Feedback Info",
  "sample_discussion_ideas": "Sample Discussion Ideas",
  "image_library": "Image Library",
  "interculturality": "Interculturality",
  "add_alternative_version_explanation": "Fügen Sie eine alternative Version des Ausdrucks hinzu, die als korrekt markiert werden soll, z. B. 'You are welcome' könnte eine Alternative zu 'You're welcome' sein.",
  "upload_video": "Video Hochladen",
  "select_video_desc": "Ziehen Sie ein Video von Ihrem Computer hierher",
  "add_video": "Video Hinzufügen",
  "video_info": "Kursvideo",
  "play_video": "Video Abspielen",
  "delete_video": "Video Löschen",
  "delete_video_confirmation": "Sind Sie sicher, dass Sie dieses Video löschen möchten?",
  "view_video": "Video Ansehen",
  "video_options": "Video-Optionen",
  "congratulations": "Congratulations!",
  "medal_has_been_added_to_your_profile": "A medal has been added to your profile",
  "pdf_options": "PDF Options",
  "disable_keyboard": "Disable Keyboard",
  "enable_keyboard": "Enable Keyboard",
  "view_story": "View Story",
  "view_question": "View Question",
  "save_library": "Save to Library",
  "minimum_two_phrases": "This exercise requires a minimum of two phrases in the topic.",
  "roleplay_not_valid": "This exercise requires a minimum of one interaction and one question.",
  "move_topic": "Move Topic",
  "move_section": "Move Section",
  "move_roleplay": "Move Roleplay",
  "duplicate_roleplay": "Duplicate Roleplay",
  "leave_game": "Leave Game",
  "leave_game_confirmation": "Are you sure you want to leave this game?",
  "leave": "Leave",
  "explore": "Explore",
  "listen": "Listen",
  "download_template": "Download Template",
  "member_activity": "Student Activity",
  "move_phrase": "Move Phrase",
  "multiple_choice": "Multiple Choice",
  "record": "Record",
  "nualang_live_help": "How to play",
  "nualang_live_help_desc": "Click here to see how to play the game",
  "roleplay-story": "Story",
  "teach_classrooms_desc": "Manage and interact with your students in a dynamic learning environment",
  "teach_classrooms_title": "Engage Your Classroom",
  "teach_courses_desc": "Design and structure your curriculum to provide a complete learning experience",
  "teach_courses_title": "Build comprehensive courses",
  "teach_roleplays_title": "A new kind of Roleplay",
  "teach_roleplays_desc": "Teaching with roleplays allows your students to participate in scripted conversations, providing a dynamic and immersive way to practice their language skills",
  "teach_bots_title": "Creativity with chatbots",
  "teach_bots_desc": "Teaching with chatbots can help your students develop confidence and a natural conversational style that flows seamlessly, similar to real-life conversations",
  "learn_bots_title": "Creativity With Chatbots",
  "learn_bots_desc": "Learning with chatbots can help you develop a natural and engaging conversational style that flows seamlessly, just like a real conversation",
  "learn_roleplays_title": "A new kind of Roleplay",
  "learn_roleplays_desc": "Learning with roleplays allows you to participate in scripted conversations, providing a dynamic and immersive way to practice language skills",
  "learn_classrooms_desc": "Join classrooms where you can interact with your peers and teachers in a dynamic learning environment",
  "learn_classrooms_title": "Interactive Learning Spaces",
  "learn_courses_desc": "Enroll in courses designed to give you a complete learning experience with structured lessons and activities",
  "learn_courses_title": "Comprehensive learning paths",
  "video_included": "Video",
  "story_included": "Story",
  "topic_no_roleplays": "This topic has no roleplays.",
  "answer_helper_text": "Press enter / return key to add answer.",
  "move_answer": "Move Answer",
  "remove_answer": "Remove Answer",
  "remove_question": "Frage entfernen",
  "supported_file_types": "Supported file types: mp4, mov",
  "exercise_description": "Listen to this phrase",
  "translate_description": "Translate the phrase as quick as you can for the most points!",
  "result_description": "See where you place against everyone else!",
  "listening_description": "Choose an answer as quick as you can for the most points!",
  "roleplay_intro": "Listen to the conversation between the two characters!",
  "case_sensitive": "This was marked for case sensitivity",
  "required_field": "Fields marked with * are required",
  "close_drawer": "Close Drawer",
  "generate_question": "Generate Question",
  "generating_question": "Generating Question",
  "experimental_feature_desc_answer": "The 'Generate Question' button is a New AI Feature - We would love to hear your feedback",
  "question_type": "Question Type",
  "multiple_choice_factual": "Multiple Choice - Factual",
  "multiple_choice_inference": "Multiple Choice - Inference",
  "vocabulary": "Vocabulary",
  "true_false": "True/False",
  "insert_emoji": "Insert Emoji",
  "moderation_reason": "Image was blocked for containing: {{moderationReason}}",
  "move_bot": "Move Chatbot",
  "duplicate_bot": "Duplicate Chatbot",
  "incomplete_translation": "There is still more to this sentence!",
  "discuss_description": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "enable_discuss": "Enable Discuss in Settings",
  "experimental_feature_desc_phrases": "The 'Generate Phrases' button is a New AI Feature - We would love to hear your feedback",
  "choose_topic_for_phrases": "What would you like the phrases to be about?",
  "how_many_phrases": "Number of Phrases: {{phraseAmount}}",
  "generate_phrases": "Generate Phrases",
  "generating_phrases": "Generating Phrases",
  "duplicate_answer_desc": "A question cannot have duplicate answers",
  "question_language": "Choose a language for the questions and answers",
  "generate_questions": "Generate Questions",
  "enable_gen_questions": "Enable this to generate comprehension questions related to the roleplay.",
  "use_topic_phrases": "Use Topic Phrases",
  "enable_phrase_context": "Enable this to use the phrases from your Topic as context in generating the roleplay.",
  "add_phrase_context": "Please add phrases to your topic to enable this feature.",
  "enter_phrase_with_alternatives": "Enter a phrase with alternatives",
  "sentences": "Sentences",
  "words": "Words",
  "phrase_type": "Phrase Type",
  "archive_classroom": "Archive Classroom",
  "archive_classroom_confirmation": "Are you sure you want to archive this classroom?",
  "unarchive_classroom": "Unarchive Classroom",
  "unarchive_classroom_confirmation": "Are you sure you want to unarchive this classroom?",
  "confirmArchiveText": "To confirm archiving, type 'archive' into the field below",
  "confirmUnarchiveText": "To confirm unarchiving, type 'unarchive' into the field below",
  "generate_bot": "Generate Chatbot",
  "generating_bot": "Generating Chatbot",
  "choose_topic_for_bot": "What would you like this chatbot to be about?",
  "use_context_from_topic_phrases": "Use topic phrases",
  "voice_speed": "Voice Speed",
  "phrase_to_speak": "Phrase to Speak",
  "voice_speed_extra_slow": "Extra Slow",
  "voice_speed_slow": "Slow",
  "voice_speed_medium": "Medium",
  "voice_speed_fast": "Fast",
  "voice_speed_extra_fast": "Extra Fast",
  "play_audio": "Play Audio",
  "generate_audio": "Generate Audio",
  "generate_bot_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "topic_goal": "Communicative goal",
  "topic_goal_info_text": "What do you want the learner to be able to do at the end of this lesson?",
  "archived_classrooms_title": "No Archived Classrooms",
  "archived_classrooms_desc": "When you're finished with a classroom, you can archive it. This will archive the classroom for all students and collaborators.",
  "bot_created": "Chatbot Created",
  "bot_deleted": "Chatbot Deleted",
  "ukrainian": "Ukrainisch",
  "arabic": "Arabic",
  "chinese_simplified": "Chinese Simplified",
  "chinese_traditional": "Chinese Traditional",
  "czech": "Czech",
  "danish": "Danish",
  "dutch": "Dutch",
  "filipino": "Filipino",
  "greek": "Greek",
  "hindi": "Hindi",
  "hungarian": "Hungarian",
  "indonesian": "Indonesian",
  "japanese": "Japanese",
  "korean": "Korean",
  "malay": "Malay",
  "polish": "Polish",
  "punjabi": "Punjabi",
  "romanian": "Romanian",
  "swahili": "Swahili",
  "thai": "Thai",
  "turkish": "Turkish",
  "vietnamese": "Vietnamese",
  "speak_disabled": "Speak disabled",
  "move_message": "Move Message",
  "move_question": "Move Question",
  "topic_goal_placeholder": "e.g I can ask and answer questions about my identity.",
  "download_csv_template": "Download CSV Template",
  "upload_csv": "Upload CSV",
  "remove_csv": "Remove CSV",
  "single_phrase": "Single Phrase",
  "list_of_phrases": "List of Phrases",
  "text_studio": "Text-to-Speech Studio",
  "text_studio_description": "The Nualas are here to help you turn text into speech, select a language and choose from our selection of voices to bring your text to life.",
  "no_phrases_yet": "No phrases yet...",
  "access_denied_domain_unverified": "Access Denied: Domain Unverified",
  "file_name": "File Name",
  "download_audio": "Download Audio",
  "no_answer": "No Answer",
  "left_group": "Left Group",
  "view_feedback": "View Feedback",
  "no_feedback": "You have not given this student feedback yet",
  "app_search_placeholder": "Search community content",
  "delete_phrases": "Delete Phrases",
  "delete_phrases_confirmation": "Are you sure you want to delete the chosen phrases?",
  "share_audio": "Please uncheck this box if you do not want to share your audio with Nualang. Sharing the audio will help us diagnose the issue.",
  "edit_phrase": "Edit phrase",
  "share_screenshot": "Please check this box if you would like to share your screenshot with Nualang. Sharing the screenshot will help us diagnose the issue.",
  "screenshot_captured": "Screenshot captured:",
  "classroom_creator_play_live_game": "Play Nualang LIVE",
  "classroom_creator_play_live_game_desc": "Nualang LIVE offers customisable games that create a dynamic and engaging environment for students, allowing them to test their skills and compete against each other to win coveted Nuala medals.",
  "content_tags": "Add Tags",
  "enter_info_tags": "Enter a comma separated list of tags below.",
  "enter_collaborator_email": "Enter a comma or space separated list of email addresses below. Collaborators can manage courses, students, and classroom settings.",
  "enter_domains_info": "Enter a comma or space separated list of school domains below.",
  "search_error": "Bei der Suche ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
  "create_feedback_error": "Beim Erstellen des Feedbacks ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
  "get_recs_error": "Beim Abrufen der Aufnahmen ist ein Fehler aufgetreten",
  "get_image_error": "Beim Abrufen der Bilder ist ein Fehler aufgetreten",
  "update_discussion_error": "Beim Aktualisieren der Diskussion ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
  "invite_users_error": "Beim Einladen der Benutzer ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
  "create_image_error": "Beim Hochladen des Bildes ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
  "grade_conversation_error": "Beim Bewerten des Gesprächs ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
  "get_transcript_error": "Beim Abrufen des Transkripts ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
  "get_subs_error": "Beim Abrufen der Einreichungen ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
  "delete_picture_confirmation": "Are you sure you want to delete this picture?",
  "inappropriate_language_detected": "Inapproriate Language Detected",
  "schedule_discussion_error": "Beim Planen der Diskussion ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
  "heritage_speaker": "Read/Write",
  "unmark_as_heritage_speaker": "Disable Read/Write Mode",
  "mark_as_heritage_speaker": "Enable Read/Write Mode",
  "heritage_speaker_desc": "Focuses on reading and writing by disabling listening and speaking where appropriate. Designed with heritage learners in mind.",
  "heritage_speaker_point_1": "The word bank will be disabled",
  "heritage_speaker_point_2": "Listening and pronunciation will be disabled where appropriate.",
  "freely_changed": "This can be freely changed at any time.",
  "mark_as_challenge_student": "Enable Challenge Mode",
  "unmark_as_challenge_student": "Disable Challenge Mode",
  "mark_as_challenge_bot": "Mark as Challenge Mode",
  "unmark_as_challenge_bot": "Unmark as Challenge Mode",
  "challenge_student": "Challenge Mode",
  "challenge_student_desc": "Unlocks chatbots that prompt extended responses and formal, academic language. Designed with heritage learners in mind.",
  "challenge_bot": "Challenge Mode",
  "challenge_bot_desc": "This chatbot is visible only to students with Challenge Mode enabled in the Students tab. Designed with heritage learners in mind, it provides formal, academic prompts.",
  "rewatch_tutorial": "Rewatch Tutorial",
  "heritage_speaker_progress": "Students marked as 'Read/Write' will have their learning experience adjusted to focus more on reading and writing.",
  "generate_transcript": "Generate Transcript",
  "suggested_images": "Suggested Images",
  "auto_generate_phrase_translation": "Generate Translations",
  "word_near_correct": "This word is correct, but it is in the wrong position",
  "partially_correct": "Partially Correct",
  "tag_info": "Tags help organize and categorize content, making it easier to find and group related materials. Use tags to improve the discoverability of your content and streamline your workflow.",
  "assignments": "Assignments",
  "assign_exercises": "Assign Exercises",
  "assign_exercises_desc": "Select activities from your curated library of content and assign them to your students with just a few clicks. Watch as they engage with exercises designed to reinforce learning, practice skills, and deepen understanding.",
  "assign_discuss": "Assign Discuss",
  "assign_discuss_desc": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "archive_discussions": "Archived Discussions",
  "archive_submissions": "Archived submissions",
  "assignment": "Assignment",
  "create_assignment": "Create Assignment",
  "no_assignments": "No Assignments",
  "assignments_description": "Assignments are a great way to engage your students with interactive content. Create assignments to reinforce learning, practice skills, and deepen understanding.",
  "no_assignments_desc": "There are no assignments in this classroom yet.",
  "select_classroom": "Select Classroom",
  "assignment_title": "Assignment Title",
  "assignment_description": "Assignment Description",
  "select_members": "Select Students",
  "schedule_assignment": "Schedule Assignment",
  "assign_date": "Available From",
  "add_exercise": "Add Exercise",
  "add_exercises": "Add Exercises",
  "assign_exercises_description": "Select exercises from your library to assign to your students",
  "due_in": "Due in",
  "due_tomorrow": "Due Tomorrow",
  "student_edited_transcript": "Der Schüler hat diese Transkription nach der Aufnahme manuell bearbeitet.",
  "member_updated": "Student updated",
  "delete_assignment": "Delete Assignment",
  "delete_assignment_confirmation": "Are you sure you want to delete this assignment?",
  "assignment_deleted": "Assignment deleted",
  "assignment_created": "Assignment created",
  "assignees_created": "Assignees created",
  "classroom_creator_subscription_expired": "The creator's subscription has expired.",
  "return_to_classrooms": "Return to Classrooms",
  "creator_not_subscribed_upgrade_title": "Subscription Expired",
  "creator_not_subscribed_upgrade": "Your subscription has expired. Please upgrade plan in order to continue the following features:",
  "creator_not_subscribed_upgrade_description": "Student access to classroom activities.",
  "creator_not_subscribed_upgrade_description2": "Ability to create Nualang LIVE games",
  "creator_not_subscribed_upgrade_description3": "Student ability to join classroom.",
  "due_today": "Due Today",
  "update_assignment": "Update Assignment",
  "refresh_assignments": "Refresh Assignments",
  "report_type": "Type",
  "go_back_to_assignments": "Go back to Assignments",
  "available_today": "Available Today",
  "available_tomorrow": "Available Tomorrow",
  "available_in": "Available in",
  "not_assigned": "Not Assigned",
  "assigned": "Assigned",
  "view_assignment": "View Assignment",
  "no_assignments_description": "There are currenly no assignments created.",
  "no_shared_courses": "Es gibt keine gemeinsamen Kurse zwischen den ausgewählten Klassenräumen.",
  "view_submissions": "View Submissions",
  "archive": "Archive",
  "discussions": "Discussions",
  "generated_phrases": "Are you sure you want to add the following generated phrases to the list? These phrases will be appended and will not replace any existing phrases.",
  "everyone": "Everyone",
  "duplicate_course_confirmation": "This will make a copy of the course that you can edit. You won't get updates or changes from the original course.",
  "duplication": "Allow others to duplicate this course.",
  "invalid_email_format": "Invalid email format",
  "email_domain_mismatch_error": "Email must be from your domain ({{domain}}).",
  "generic_email_domain_error": "Generic email domain error",
  "duplicate_disabled_tooltip": "This course has been disabled for duplication by the creator.",
  "collaborators_only": "Collaborators",
  "hide_course": "Hide Course",
  "show_course": "Show Course",
  "default_assignment_title": "New Classroom Assignment",
  "default_assignment_instructions": "Please complete the tasks below before the due date.",
  "due": "Due",
  "hide_from_students": "Hide from Students",
  "show_to_students": "Show to Students",
  "hello": "Hallo",
  "dynamic_response": "Dynamic Responses",
  "dynamic_response_desc": "Allow Chatbots in this Classroom to generate customized replies based on student input, powered by AI.",
  "assign_to": "Assign To",
  "all_students": "All Students",
  "ai_chatbot_message_info": "This chatbot message is generated using AI.",
  "ai_chatbot_message_generating_info": "This chatbot message is being generated using AI.",
  "language_correction": "Sprachkorrektur",
  "correction_original": "Original",
  "correction_suggested": "Vorschlag",
  "language_corrections_to_review": "Sprachkorrekturen zum Wiederholen",
  "dynamic_responses_info": "Enabling this feature allows the Chatbots to use AI to generate personalized responses based on what students say. While this can support more engaging learning, responses are automatically generated and may vary. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "paste_your_csv_data": "Paste your CSV data here",
  "user_level_settings": "Benutzereinstellungen",
  "chatbot_dynamic_responses": "Chatbot - Dynamische Antworten",
  "chatbot_dynamic_responses_desc": "Wenn die dynamische Antwort aktiviert ist, hört der Chatbot aktiv zu und passt sich an, indem er nach mehr Details, klarerer Formulierung oder realistischeren Antworten fragt, anstatt einfach zur nächsten vordefinierten Eingabeaufforderung überzugehen.",
  "chatbot_now_ai": "Nualang Chatbot: Now with Real-Time Feedback",
  "chatbot_now_ai_desc": "More speaking support. Same structure. No extra work. Students now get helpful, AI-enhanced feedback as they chat!",
  "chatbot_now_ai_revert_settings": "You can limit AI anytime in your ",
  "prefer_original_version": "Prefer the original version?",
  "chatbot_now_ai_benefit": "It’s like giving every student a conversation coach built right into the activity—with zero extra prep or grading.",
  "ai_learn_more": "Want to learn more? Read our approach to AI safety and trust.",
  "ai_settings_desc": "Choose which AI features are available in this classroom.",
  "limit_ai": "AI in this classroom",
  "limit_ai_desc": "Allow the AI features below in this classroom or disable them entirely.",
  "limit_ai_info": "Disabling AI in this classroom turns off each AI feature below at once: Chatbot dynamic responses and AI-generated feedback on Discuss recordings. Teachers can still write and submit their own feedback. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "limit_ai_course_desc": "Turn chatbot dynamic responses off for this course only. The classroom setting applies unless you change it here.",
  "chatbot_ai": "Chatbot - Dynamic Responses",
  "chatbot_ai_desc": "Allow AI to generate feedback and responses to students or disable to use scripted replies.",
  "discuss_ai": "Discuss - AI feedback",
  "discuss_ai_desc": "Allow AI to generate draft feedback on student submissions or disable to require teacher created feedback only.",
  "ai_allowed": "Enabled",
  "ai_limited": "Disabled",
  "ai_limited_classroom_notice": "AI is disabled in this classroom, the features below are unavailable.",
  "ai_locked_notice": "AI is limited for your whole organization, so it cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_partly_locked_notice": "Some AI features are limited for your whole organization, so they cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_overview_desc": "AI settings for every classroom you teach, including ones you co-teach. Changes apply to the classroom straight away.",
  "ai_overview_empty": "You don't teach any classrooms yet.",
  "ai_overview_load_failed": "Your classrooms could not be loaded. Please try again.",
  "ai_overview_save_failed": "This change could not be saved",
  "ai_overview_apply_all": "Apply to all",
  "ai_overview_enable_all": "Enable for all classrooms",
  "ai_overview_disable_all": "Disable for all classrooms",
  "ai_overview_apply_all_count": "Classrooms that will change",
  "ai_overview_apply_all_skips": "Archived classrooms, and settings fixed by your organization, are not changed.",
  "ai_overview_apply_all_saved": "Classrooms updated",
  "ai_overview_apply_all_failed": "These classrooms could not be updated",
  "ai_overview_course_overrides": "Courses with the chatbot disabled",
  "ai_overview_open_classroom": "Classroom settings",
  "ai_overview_no_active": "All your classrooms are archived.",
  "ai_course_overrides_notice": "Allowed for this classroom, but disabled for these courses",
  "ai_per_course_hint": "You can also limit chatbot dynamic responses for individual courses in Course settings below.",
  "ai_limited_feedback_blocked": "AI is limited for this classroom, so AI feedback cannot be generated.",
  "ai_settings": "AI Settings",
  "student_sent_inappropriate_messages": "Das untenstehende Transkript erfordert Ihre Überprüfung.",
  "challenge_mode": "Challenge Mode",
  "student_misuse_reported": "Student Misuse Reported",
  "student_acts_inappropriately": "Ein Schüler verhält sich unangemessen während einer Chatbot-Übung",
  "ai_chatbot_error_response": "Entschuldigen Sie, dass ich in meiner Antwort einen Fehler gemacht habe. Bitte versuchen Sie es erneut!",
  "no_members_tooltip": "Cannot perform this action because there are no students or courses in this classroom.",
  "overdue": "Overdue",
  "due_next": "Due Next",
  "active": "Active",
  "archived": "Archived",
  "past_due": "Past Due",
  "available_from": "Available from",
  "roleplay-fill-in-the-blanks": "Scenario fill in the blanks",
  "roleplay-act-it-out": "Scenario act it out",
  "roleplay-act-it-out-listening": "Scenario act it out listening",
  "roleplay-act-it-out-speaking": "Scenario act it out speaking",
  "roleplay-act-it-out-listening-speaking": "Scenario act it out listening and speaking",
  "generate_discussion": "Generate Discussion",
  "generating_discussion": "Generating Discussion",
  "discuss_prompt_language": "Choose a language for the discussion prompt",
  "level": "Level",
  "grouped_discussion": "Grouped Discussion",
  "not_present": "Was not present for the discussion",
  "view_recording": "View Recording",
  "generate_feedback": "Generate Feedback",
  "generate_feedback_for_all": "Generate Feedback for All",
  "performance_rating": "Performance Rating",
  "feedback_submitted": "Feedback Submitted",
  "group_not_submitted": "Group has not submitted a recording yet",
  "this_classroom_is_archived": "This classroom is archived",
  "submission_graded": "Submission Graded",
  "view_submission": "View Submission",
  "show_more": "Show more",
  "show_less": "Show less",
  "submit_feedback_confirmation": "Have you reviewed all generated feedback and are you ready to submit it to students?",
  "submit_feedback_scroll": "Review all feedback before submitting it to students",
  "ai_draft_not_edited": "AI draft, not edited",
  "edited_by_you": "Edited by you",
  "approved": "Approved",
  "approve": "Approve",
  "undo": "Undo",
  "x_of_n": "{{x}} of {{n}}",
  "ai_drafts_reviewed": "AI drafts reviewed",
  "approve_ai_drafts_to_submit_one": "Approve {{count}} AI draft to submit",
  "approve_ai_drafts_to_submit_other": "Approve {{count}} AI drafts to submit",
  "ai_suggested": "AI-suggested",
  "ai_suggested_tooltip": "Your teacher used AI to draft this feedback and sent it to you.",
  "course_topic": "Course Topic",
  "discussion_topic_helper": "Select a relevant topic to help generate the discussion.",
  "no_groups_created_yet": "No groups created yet",
  "select_students_from_the_list": "Select students from the list on the left to create a group",
  "drop_members_here": "Drop students here to create a group",
  "drag_a_student_here": "Drag a student here to create a group",
  "new_group": "New Group",
  "cannot_edit_discussion": "Cannot edit discussion with existing submissions",
  "generating_feedback": "Generating Feedback",
  "conversations_graded_success": "Feedback Generated",
  "below_level": "Below Level",
  "at_level": "At Level",
  "above_level": "Above Level",
  "ai_performance_assessment": "AI Performance Assessment",
  "performance_chip_tooltip": "Indicates how a student’s performance compares to the expected proficiency range, based on AI analysis.",
  "performance_chip_note": "Visible only to teachers and intended to support instructional review.",
  "you_are_human": "Wenn du ein Mensch bist, lass dieses Feld leer",
  "progress": "Fortschgritt",
  "no_scheduled_assignments": "No Scheduled Assignments",
  "no_past_due_assignments": "No Past Due Assignments",
  "no_past_due_discussions": "No Past Due Discussions",
  "no_archived_discussions": "No Archived Discussions",
  "no_discussions": "No Discussions",
  "no_discussions_description": "Discussions are a great way to engage your students with collaborative conversations. Create discussions to practice speaking, build confidence, and develop communication skills.",
  "meaning": "Meaning",
  "meaning_exercise_desc": "Match definitions to the correct phrase.",
  "meaning-listen-and-speak": "Bedeutung - Hören & Sprechen",
  "meaning_listen_and_speak_exercise_desc": "Hören Sie die Definition und sprechen Sie den passenden Satz.",
  "meaning-read-and-write": "Bedeutung - Lesen & Schreiben",
  "select_the_correct_phrase": "Wähle den richtigen Ausdruck für diese Definition",
  "chinese": "Chinesisch",
  "custom_feedback_placeholder": "Optional: Fügen Sie zusätzliche Anweisungen hinzu, um das Feedback zu fokussieren (z. B. Genauigkeit, Komplexität oder Verwendung von Zielstrukturen).",
  "generate_feedback_view_the": "Sehen Sie sich die",
  "generate_feedback_rubric_name": "Analytische Wachstumsrubrik",
  "generate_feedback_rubric_desc": "die Kriterien, die in unserem KI-Feedback verwendet werden.",
  "late_submission": "Verspätete Einreichung",
  "days_late_one": "{{count}} Tag zu spät",
  "days_late_other": "{{count}} Tage zu spät",
  "phrase_definition": "Satzdefinition",
  "phrase_definition_helper_text": "Drücken Sie die Eingabetaste, um die Definition hinzuzufügen.",
  "generate_definitions": "Definitionen generieren",
  "phrases_exercise_desc": "Practice key phrases you'll use in conversations.",
  "phrase_group_name": "Phrase List Name",
  "create_phrase_group": "Create Phrase List",
  "preview_phrases": "Preview Phrases",
  "show_keyboard": "Show Keyboard",
  "hide_exercise": "Hide Exercise",
  "phrase_list": "Phrase List",
  "phrase_lists": "Phrasenlisten",
  "no_phrase_lists": "Keine Phrasenlisten",
  "all_phrase_lists": "Alle Phrasenlisten",
  "edit_phrase_list": "Edit Phrase List",
  "hide_phrase_list": "Hide Phrase List",
  "move_phrase_list": "Move Phrase List",
  "remove_phrase_list": "Remove Phrase List",
  "show_exercise": "Show Exercise",
  "hide_keyboard": "Hide Keyboard",
  "editor": "Editor",
  "phrase_list_name": "Phrase List Name",
  "phrase_list_information": "Phrase List Information",
  "build_meaning": "Build Meaning",
  "read_and_write": "Read & Write",
  "meaning_listen_and_speak": "Listen & Speak",
  "hide_phrases_exercise": "Hide Phrases",
  "show_phrases_ecercise": "Show Phrases",
  "generate_defintions_error": "Beim Generieren der Definitionen ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
  "saving_defintions_error": "Beim Speichern der Definitionen ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
  "auto_generate_definitions": "Definitionen generieren",
  "generating_definitions": "Definitionen generieren",
  "definitions": "Definitionen",
  "view_phrase_list": "Liste der Phrasen anzeigen",
  "meaning_exercise_welcome": "Willkommen zum Bedeutungsexercice",
  "meaning_exercise_definition": "Definition",
  "meaning_exercise_definition_desc": "Wählen Sie die richtige Definition für diesen Satz",
  "meaning_exercise_options": "Optionen",
  "meaning_exercise_options_desc": "Wählen Sie die richtigen Optionen für diesen Satz",
  "meaning_no_definitions": "This phrase list has no definitions",
  "definition": "Definition",
  "review_generated_definitions": "Review Generated Definitions",
  "new_definitions": "New Definition",
  "current_definitions": "Current Definition",
  "play_phrase_list": "Play Phrase List",
  "transfer_phrases": "Kopieren nach",
  "transfer": "Kopieren",
  "create_phrase_list_from_selection": "Neue Phrasenliste erstellen",
  "no_other_phrase_lists": "Keine anderen Phrasenlisten",
  "add_row": "Zeile hinzufügen",
  "problem_updating": "Beim Aktualisieren ist ein Problem aufgetreten",
  "exercise_settings": "Übungseinstellungen",
  "excercise_voice": "Übungsstimme",
  "excercise_voice_desc": "Wählen Sie die Stimme aus, die in Übungen für diese Phrasenliste verwendet wird.",
  "excercise_visibility": "Übungssichtbarkeit",
  "keyboard": "Tastatur",
  "legacy_voice_tooltip_text": "Older voice technology. May sound less natural.",
  "listen_and_speak_exercise_desc": "Listen to the definition. Say the phrase.",
  "identify_this_phrase": "Identify this phrase",
  "listen_and_speak_exercise_welcome": "Getting started with the Listen & Speak Exercise",
  "listen_and_speak_exercise_speak_desc": "Click to listen to how the definition",
  "listen_and_speak_exercise_listen": "Listen to the definition!",
  "listen_and_speak_exercise_voice_input": "Pronounce the phrase that matches the definition",
  "hide_phrase_image": "Hide phrase image",
  "show_phrase_image": "Show phrase image",
  "read_the_definition": "Lies die Definition",
  "read_write_exercise_welcome": "Welcome to the Read & Write Exercise",
  "read_write_exercise_definition": "Definition",
  "read_write_exercise_definition_desc": "Read the definition shown here",
  "read_write_exercise_options": "Type the Phrase",
  "read_write_exercise_options_desc": "Type the correct phrase in the text box",
  "play_phrase": "Satz abspielen",
  "type_the_correct_phrase": "Geben Sie den richtigen Satz ein",
  "read_write": "Lesen & Schreiben",
  "meaning_read_write": "Bedeutung - Lesen & Schreiben",
  "meaning_read_write_exercise_desc": "Lesen Sie die Definition und geben Sie den richtigen Satz ein.",
  "course_description_default": "This is a course to help students speak {{learnLang}} with confidence.",
  "image_builder": "Image Builder",
  "background_color": "Background Color",
  "icon": "Icon",
  "pattern_density": "Pattern Density",
  "use_image": "Use Image",
  "background_colour": "Background Colour",
  "icon_opacity": "Icon Opacity",
  "custom_colour": "Custom Colour",
  "create_chatbot": "Chatbot erstellen",
  "find_chatbot": "Chatbot finden",
  "find_chatbots": "Chatbots finden",
  "add_chatbot": "Chatbot hinzufügen",
  "add_chatbots": "Chatbots hinzufügen",
  "template": "Vorlage",
  "chatbot_name": "Chatbot-Name",
  "create_scenario": "Rollenspiel erstellen",
  "find_scenario": "Rollenspiel finden",
  "find_scenarios": "Rollenspiele finden",
  "scenario_name": "Name des Rollenspiels",
  "scenarios_added": "Rollenspiele zum Thema hinzugefügt",
  "chatbots_added": "Chatbots zum Thema hinzugefügt",
  "add_scenarios": "Rollenspiele hinzufügen",
  "achievements": "Erfolge",
  "topic_description_default": "This is a topic to help students speak {{learnLang}} with confidence.",
  "selected_topics": "Selected Topics",
  "no_topics_selected": "No topics selected",
  "add_topics": "Add topics",
  "find_topics": "Find topics",
  "find_topic": "Find Topic",
  "no_topics_found": "No topics found",
  "no_library_topics_community_hint": "Finde Themen, die von anderen Lehrkräften erstellt wurden, im Tab <1>Community</1>.",
  "chatbot_title": "Titel des Chatbots",
  "open_ended": "Offen beendet",
  "open_ended_desc": "Lassen Sie Ihre Schüler mit eigenen Worten antworten.",
  "quiz": "Quiz",
  "quiz_desc": "Führen Sie den Schüler durch eine Reihe von Fragen.",
  "picture_quiz": "Bild Quiz",
  "picture_quiz_desc": "Stellen Sie Fragen anhand von Bildern.",
  "emoji_quiz": "Emoji Quiz",
  "emoji_quiz_desc": "Errate die Antwort basierend auf den Emojis.",
  "quiz_style_templates": "Vorlagen im Quiz-Stil",
  "no_scenarios_found": "Keine Szenarien gefunden",
  "no_chatbots_found": "Keine Chatbots gefunden",
  "use_voice": "Stimme verwenden",
  "internal_view_provider_marks": "Interne Ansicht · Anbieterbewertungen sichtbar",
  "legacy": "Veraltet",
  "scan_to_open_the_classroom": "Scannen, um das Klassenzimmer zu öffnen",
  "classroom_link": "Klassenzimmer-Link",
  "copy": "Kopieren",
  "tell_students_to": "Sagen Sie den Schülern,",
  "invite_step_sign_in": "sich in ihrem Konto anzumelden.",
  "invite_step_scan": "den Code zu scannen oder das Klassenzimmer zu öffnen.",
  "invite_step_tap_join": "auf {{button}} zu tippen.",
  "select_exercise_phrases_intro": "Markieren Sie die Ausdruckslisten, die Sie spielen möchten. Sie können Listen aus verschiedenen Kursen kombinieren.",
  "select_exercise_scenarios_intro": "Wählen Sie ein Szenario, das Sie live mit der Klasse spielen möchten.",
  "source_type_phrase_lists": "Ausdruckslisten",
  "source_type_scenarios": "Szenarien",
  "clear_all": "Alles löschen",
  "n_of_m_lists_selected": "{{n}} von {{m}} Listen ausgewählt",
  "n_phrase_lists": "{{count}} Ausdruckslisten",
  "n_phrases": "{{count}} Ausdrücke",
  "has_definitions": "mit Definitionen",
  "n_scenarios": "{{count}} Szenarien",
  "n_messages": "{{count}} Nachrichten",
  "n_interactions": "{{count}} Interaktionen",
  "lists_and_phrases_selected": "{{lists}} Listen · {{phrases}} Ausdrücke",
  "no_lists_selected": "Keine Listen ausgewählt",
  "no_scenario_selected": "Kein Szenario ausgewählt",
  "scenario_selected": "Szenario ausgewählt",
  "number_of_messages": "Anzahl der Nachrichten",
  "max_phrases_label": "Max",
  "max_phrases_all": "Alle {{count}}",
  "estimated_game_time_hint": "{{questions}} Fragen zu je {{seconds}} s, plus Feedback zwischen den Runden.",
  "n_minutes": "{{count}} Minuten",
  "live_game_title": "{{exercise}} · {{count}} Ausdruckslisten",
  "phrases_from": "Ausdrücke aus",
  "source_card_meta": "{{topic}} · {{count}} Ausdrücke",
  "n_more": "weitere",
  "waiting_for_students": "Warten darauf, dass Schüler beitreten.",
  "how_students_answer": "Wie Schüler antworten",
  "answer_keyboard_and_word_bank": "Tastatur und Wortbank",
  "answer_keyboard_and_word_bank_hint": "Schüler tippen, mit Wortkacheln als Hilfe.",
  "answer_keyboard_only": "Nur Tastatur",
  "answer_keyboard_only_hint": "Am schwersten – Schüler tippen die ganze Antwort.",
  "answer_word_bank_only": "Nur Wortbank",
  "answer_word_bank_only_hint": "Am einfachsten – Schüler tippen Wörter an die richtige Stelle.",
  "time_per_question": "Zeit pro Frage",
  "all_n_phrases": "Alle {{count}} Ausdrücke",
  "includes_one_from_each_list": "Mindestens ein Ausdruck aus jeder ausgewählten Liste ist immer enthalten.",
  "chatbot": "Chatbot",
  "scenario": "Scenario",
  "conversation": "Conversation",
  "from_course": "From course",
  "from_course_named": "From course: {{title}}",
  "start_topic": "Start topic",
  "start_chat": "Start chat",
  "start_scenario": "Start scenario",
  "n_activities": "{{number}} activities",
  "roleplay_turns": "Roleplay · {{number}} turns",
  "filter_by_type": "Filter by type",
  "view_course_named": "View {{title}}",
  "show": "Show",
  "content_type": "Content type",
  "all_content": "all content",
  "results_summary": "{{number}} results for “{{query}}” · {{types}}",
  "n_results_named": "{{label}}, {{number}} results",
  "view_chatbot": "View chatbot",
  "view_scenario": "View scenario",
  "all_languages": "Alle Sprachen",
  "all_levels": "Alle Niveaus",
  "novice": "Anfänger",
  "intermediate": "Mittelstufe",
  "advanced": "Fortgeschritten",
  "popular": "Beliebt",
  "courses_shared_by_other_teachers": "Kurse, die von anderen Lehrkräften geteilt wurden",
  "no_created_courses_match": "Keine erstellten Kurse entsprechen diesen Filtern",
  "no_joined_courses_match": "Keine verbundenen Kurse entsprechen diesen Filtern",
  "no_community_courses_match": "Keine Kurse entsprechen diesen Filtern",
  "courses_added": "Kurse hinzugefügt",
  "problem_adding_courses": "Es gab ein Problem beim Hinzufügen dieser Kurse",
  "search_topics_placeholder": "Themen suchen",
  "search_classrooms_placeholder": "Klassenzimmer suchen",
  "search_student_name": "Studentennamen suchen",
  "search_sections_and_topics": "Abschnitte und Themen durchsuchen",
  "clear_search": "Suche löschen",
  "x_of_y": "{{shown}} von {{total}}",
  "outline_filter_count": "{{topics}} in {{sections}}",
  "topic_count_one": "{{count}} Thema",
  "topic_count_other": "{{count}} Themen",
  "section_count_one": "{{count}} Abschnitt",
  "section_count_other": "{{count}} Abschnitten",
  "no_sections_or_topics_match": "Keine Abschnitte oder Themen gefunden",
  "try_different_keyword_or_difficulty": "Versuche ein anderes Stichwort oder einen anderen Schwierigkeitsgrad.",
  "nothing_matches_keyword_at_difficulty": "Keine Treffer für „{{keyword}}“ mit Schwierigkeitsgrad {{difficulty}}. Versuche ein anderes Stichwort oder einen anderen Schwierigkeitsgrad.",
  "session_feedback": "Dein Feedback",
  "session_feedback_preparing": "Dein Feedback wird vorbereitet…",
  "session_feedback_unavailable": "Dein Feedback ist gerade nicht verfügbar.",
  "suggested_level": "Vorgeschlagenes Niveau",
  "session_report": "Gesprächsfeedback",
  "view_full_report": "Vollständiges Feedback ansehen",
  "rating_approaching": "Annähernd",
  "rating_meets": "Erfüllt",
  "rating_exceeds": "Übertrifft",
  "area_of_strength": "Stärke",
  "area_for_growth": "Entwicklungsbereich",
  "rating_not_yet": "Noch nicht",
  "session_report_short_interaction": "Interaktion",
  "session_report_short_vocabulary": "Wortschatz",
  "session_report_short_function": "Funktion",
  "session_report_strength": "Stärke",
  "session_report_growth": "Entwicklung",
  "ai_generated_report": "KI-generiertes Feedback",
  "ai_generated_report_tooltip": "Von KI nur aus dieser Sitzung erstellt. Das vorgeschlagene Niveau und die Bewertungen sind Einschätzungen, keine endgültige Einstufung.",
  "session_report_new": "Neu",
  "chatbot_mode_name": "Chatbot - {{mode}}",
  "chatbot_message_count": "{{count}} Nachrichten",
  "chatbot_message_count_one": "{{count}} Nachricht",
  "chatbot_message_count_other": "{{count}} Nachrichten",
  "attempt_count": "{{count}} Versuche",
  "attempt_count_one": "{{count}} Versuch",
  "attempt_count_other": "{{count}} Versuche",
  "of_total_correct": "von {{total}} richtig",
  "attempts_to_review": "Zu überprüfende Versuche",
  "attempts_not_shown": "Nicht angezeigt: {{items, list}}",
  "count_correct": "{{count}} richtig",
  "count_incorrect": "{{count}} falsch",
  "count_skipped": "{{count}} übersprungen",
  "count_partially_correct": "{{count}} teilweise richtig",
  "view_all_count": "Alle {{count}} ansehen",
  "view_attempt": "Versuch ansehen",
  "scenario_description_default": "Dieses Szenario hilft Lernenden, selbstbewusst {{learnLang}} zu sprechen."
}
